"use strict";
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_RECOVERY_LOAN_KEY = exports.fetchGetDrawDownRepaymentScheduleIwocapay = exports.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_IWOCAPAY_KEY = exports.fetchGetDrawDownRepaymentScheduleFlexi24 = exports.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_FLEXI_24_KEY = exports.fetchGetDrawDownRepaymentScheduleCreditFacility = exports.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_CREDIT_FACILITY_KEY = exports.fetchPutDocumentUpload = exports.PUT_DOCUMENT_UPLOAD_KEY = exports.fetchPostDocumentUpload = exports.POST_DOCUMENT_UPLOAD_KEY = exports.fetchGetDocumentUpload = exports.GET_DOCUMENT_UPLOAD_KEY = exports.fetchGetDocumentFeedback = exports.GET_DOCUMENT_FEEDBACK_KEY = exports.fetchGetDirectorSearch = exports.GET_DIRECTOR_SEARCH_KEY = exports.fetchGetContext = exports.GET_CONTEXT_KEY = exports.fetchGetContextByStateKey = exports.GET_CONTEXT_BY_STATE_KEY_KEY = exports.fetchGetCompanySearch = exports.GET_COMPANY_SEARCH_KEY = exports.fetchGetAssociatedPeople = exports.GET_ASSOCIATED_PEOPLE_KEY = exports.fetchGetApplicationsOffers = exports.GET_APPLICATIONS_OFFERS_KEY = exports.fetchPostApplicationRefresh = exports.POST_APPLICATION_REFRESH_KEY = exports.fetchPostApplicationDefer = exports.POST_APPLICATION_DEFER_KEY = exports.fetchPostApplicationDecline = exports.POST_APPLICATION_DECLINE_KEY = exports.fetchPostApplicationCustomerConfirmedProvidingDocs = exports.POST_APPLICATION_CUSTOMER_CONFIRMED_PROVIDING_DOCS_KEY = exports.fetchGetApplicationCustomerConfirmedProvidingDocs = exports.GET_APPLICATION_CUSTOMER_CONFIRMED_PROVIDING_DOCS_KEY = exports.fetchPutApplication = exports.PUT_APPLICATION_KEY = exports.fetchPostApplication = exports.POST_APPLICATION_KEY = exports.fetchGetApplication = exports.GET_APPLICATION_KEY = exports.fetchPostAnonymisedDataEvaluation = exports.POST_ANONYMISED_DATA_EVALUATION_KEY = exports.fetchGetAccounts = exports.GET_ACCOUNTS_KEY = exports.LapiError = exports.fetchLendingAPIJSON = exports.fetchLendingAPI = void 0;
exports.POST_FORMAL_OFFERS_FLEXI_24_COMMISSION_CONSENT_KEY = exports.fetchGetFormalOffersFlexi24CommissionConsent = exports.GET_FORMAL_OFFERS_FLEXI_24_COMMISSION_CONSENT_KEY = exports.fetchPutFormalOffersCreditFacilityConfiguration = exports.PUT_FORMAL_OFFERS_CREDIT_FACILITY_CONFIGURATION_KEY = exports.fetchGetFormalOffersCreditFacilityConfiguration = exports.GET_FORMAL_OFFERS_CREDIT_FACILITY_CONFIGURATION_KEY = exports.fetchPostFormalOffersCreditFacilityCommissionConsent = exports.POST_FORMAL_OFFERS_CREDIT_FACILITY_COMMISSION_CONSENT_KEY = exports.fetchGetFormalOffersCreditFacilityCommissionConsent = exports.GET_FORMAL_OFFERS_CREDIT_FACILITY_COMMISSION_CONSENT_KEY = exports.fetchPutFormalOffersCbilsConfiguration = exports.PUT_FORMAL_OFFERS_CBILS_CONFIGURATION_KEY = exports.fetchGetFormalOffersCbilsConfiguration = exports.GET_FORMAL_OFFERS_CBILS_CONFIGURATION_KEY = exports.fetchPostFormalOffersCbilsCommissionConsent = exports.POST_FORMAL_OFFERS_CBILS_COMMISSION_CONSENT_KEY = exports.fetchGetFormalOffersCbilsCommissionConsent = exports.GET_FORMAL_OFFERS_CBILS_COMMISSION_CONSENT_KEY = exports.fetchPutFormalOffersBusinessLoanConfiguration = exports.PUT_FORMAL_OFFERS_BUSINESS_LOAN_CONFIGURATION_KEY = exports.fetchGetFormalOffersBusinessLoanConfiguration = exports.GET_FORMAL_OFFERS_BUSINESS_LOAN_CONFIGURATION_KEY = exports.fetchPostFormalOffersBusinessLoanCommissionConsent = exports.POST_FORMAL_OFFERS_BUSINESS_LOAN_COMMISSION_CONSENT_KEY = exports.fetchGetFormalOffersBusinessLoanCommissionConsent = exports.GET_FORMAL_OFFERS_BUSINESS_LOAN_COMMISSION_CONSENT_KEY = exports.fetchPostFormalOffers = exports.POST_FORMAL_OFFERS_KEY = exports.fetchGetFormalOffers = exports.GET_FORMAL_OFFERS_KEY = exports.fetchPostFormalIndicativeOffers = exports.POST_FORMAL_INDICATIVE_OFFERS_KEY = exports.fetchGetFormalIndicativeOffers = exports.GET_FORMAL_INDICATIVE_OFFERS_KEY = exports.fetchGetExampleRepaymentSchedule = exports.GET_EXAMPLE_REPAYMENT_SCHEDULE_KEY = exports.fetchGetEmailAvailability = exports.GET_EMAIL_AVAILABILITY_KEY = exports.fetchPostEcommerceSellerOrder = exports.POST_ECOMMERCE_SELLER_ORDER_KEY = exports.fetchGetEcommerceOrder = exports.GET_ECOMMERCE_ORDER_KEY = exports.fetchDeleteEcommerceOrder = exports.DELETE_ECOMMERCE_ORDER_KEY = exports.fetchPostEarlyRepaymentTruelayer = exports.POST_EARLY_REPAYMENT_TRUELAYER_KEY = exports.fetchGetEarlyRepaymentSimulation = exports.GET_EARLY_REPAYMENT_SIMULATION_KEY = exports.fetchGetDrawDownRepaymentScheduleRecoveryLoan = void 0;
exports.GET_FUNDING_REQUIREMENTS_CREDIT_FACILITY_KEY = exports.fetchGetFundingRequirementsCbils = exports.GET_FUNDING_REQUIREMENTS_CBILS_KEY = exports.fetchGetFundingRequirementsBusinessLoan = exports.GET_FUNDING_REQUIREMENTS_BUSINESS_LOAN_KEY = exports.fetchPostFundingRequestRecoveryLoan = exports.POST_FUNDING_REQUEST_RECOVERY_LOAN_KEY = exports.fetchPostFundingRequestMerchantCashAdvance = exports.POST_FUNDING_REQUEST_MERCHANT_CASH_ADVANCE_KEY = exports.fetchPostFundingRequestIwocapay = exports.POST_FUNDING_REQUEST_IWOCAPAY_KEY = exports.fetchPostFundingRequestFlexi24 = exports.POST_FUNDING_REQUEST_FLEXI_24_KEY = exports.fetchPostFundingRequestCreditFacility = exports.POST_FUNDING_REQUEST_CREDIT_FACILITY_KEY = exports.fetchPostFundingRequestCbils = exports.POST_FUNDING_REQUEST_CBILS_KEY = exports.fetchPostFundingRequestBusinessLoan = exports.POST_FUNDING_REQUEST_BUSINESS_LOAN_KEY = exports.fetchPostFundSellerRequest = exports.POST_FUND_SELLER_REQUEST_KEY = exports.fetchPutFormalOffersRecoveryLoanConfiguration = exports.PUT_FORMAL_OFFERS_RECOVERY_LOAN_CONFIGURATION_KEY = exports.fetchGetFormalOffersRecoveryLoanConfiguration = exports.GET_FORMAL_OFFERS_RECOVERY_LOAN_CONFIGURATION_KEY = exports.fetchPostFormalOffersRecoveryLoanCommissionConsent = exports.POST_FORMAL_OFFERS_RECOVERY_LOAN_COMMISSION_CONSENT_KEY = exports.fetchGetFormalOffersRecoveryLoanCommissionConsent = exports.GET_FORMAL_OFFERS_RECOVERY_LOAN_COMMISSION_CONSENT_KEY = exports.fetchPutFormalOffersMerchantCashAdvanceConfiguration = exports.PUT_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_CONFIGURATION_KEY = exports.fetchGetFormalOffersMerchantCashAdvanceConfiguration = exports.GET_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_CONFIGURATION_KEY = exports.fetchPostFormalOffersMerchantCashAdvanceCommissionConsent = exports.POST_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_COMMISSION_CONSENT_KEY = exports.fetchGetFormalOffersMerchantCashAdvanceCommissionConsent = exports.GET_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_COMMISSION_CONSENT_KEY = exports.fetchPutFormalOffersIwocapayConfiguration = exports.PUT_FORMAL_OFFERS_IWOCAPAY_CONFIGURATION_KEY = exports.fetchGetFormalOffersIwocapayConfiguration = exports.GET_FORMAL_OFFERS_IWOCAPAY_CONFIGURATION_KEY = exports.fetchPostFormalOffersIwocapayCommissionConsent = exports.POST_FORMAL_OFFERS_IWOCAPAY_COMMISSION_CONSENT_KEY = exports.fetchGetFormalOffersIwocapayCommissionConsent = exports.GET_FORMAL_OFFERS_IWOCAPAY_COMMISSION_CONSENT_KEY = exports.fetchPutFormalOffersFlexi24Configuration = exports.PUT_FORMAL_OFFERS_FLEXI_24_CONFIGURATION_KEY = exports.fetchGetFormalOffersFlexi24Configuration = exports.GET_FORMAL_OFFERS_FLEXI_24_CONFIGURATION_KEY = exports.fetchPostFormalOffersFlexi24CommissionConsent = void 0;
exports.GET_IWOCAPAY_PAY_LINK_PACKAGE_KEY = exports.fetchPostIwocapayNotifications = exports.POST_IWOCAPAY_NOTIFICATIONS_KEY = exports.fetchPostIwocapayBuyerSpendingLimitRequest = exports.POST_IWOCAPAY_BUYER_SPENDING_LIMIT_REQUEST_KEY = exports.fetchGetIwocapayBuyerSpendingLimitRequest = exports.GET_IWOCAPAY_BUYER_SPENDING_LIMIT_REQUEST_KEY = exports.fetchPostIwocapayBuyerRefreshSpendingLimit = exports.POST_IWOCAPAY_BUYER_REFRESH_SPENDING_LIMIT_KEY = exports.fetchGetIwocapayBuyerPayLinks = exports.GET_IWOCAPAY_BUYER_PAY_LINKS_KEY = exports.fetchGetIwocapayBuyerPayLinkPackage = exports.GET_IWOCAPAY_BUYER_PAY_LINK_PACKAGE_KEY = exports.fetchPostIntroducerLinkOpenBankingEmail = exports.POST_INTRODUCER_LINK_OPEN_BANKING_EMAIL_KEY = exports.fetchGetIntroducerContext = exports.GET_INTRODUCER_CONTEXT_KEY = exports.fetchGetIntroducerContextByIntroducerId = exports.GET_INTRODUCER_CONTEXT_BY_INTRODUCER_ID_KEY = exports.fetchGetIntroducerApplications = exports.GET_INTRODUCER_APPLICATIONS_KEY = exports.fetchGetIntroducerApplicationRejectOfferReasons = exports.GET_INTRODUCER_APPLICATION_REJECT_OFFER_REASONS_KEY = exports.fetchPutIntroducerApplicationOfferWithdrawalFeeRate = exports.PUT_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = exports.fetchGetIntroducerApplicationOfferWithdrawalFeeRate = exports.GET_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = exports.fetchGetIntroducerApplicationOfferFundingRequirements = exports.GET_INTRODUCER_APPLICATION_OFFER_FUNDING_REQUIREMENTS_KEY = exports.fetchPutIntroducerApplicationOfferEntityToContact = exports.PUT_INTRODUCER_APPLICATION_OFFER_ENTITY_TO_CONTACT_KEY = exports.fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates = exports.GET_INTRODUCER_APPLICATION_OFFER_ALLOWED_WITHDRAWAL_FEE_RATES_KEY = exports.fetchGetIntroducerApplication = exports.GET_INTRODUCER_APPLICATION_KEY = exports.fetchGetIntroducer = exports.GET_INTRODUCER_KEY = exports.fetchGetIntroducerRepaymentSimulator = exports.GET_INTRODUCER_REPAYMENT_SIMULATOR_KEY = exports.fetchPostIntroducer = exports.POST_INTRODUCER_KEY = exports.fetchGetFundingRequirementsRecoveryLoan = exports.GET_FUNDING_REQUIREMENTS_RECOVERY_LOAN_KEY = exports.fetchGetFundingRequirementsMerchantCashAdvance = exports.GET_FUNDING_REQUIREMENTS_MERCHANT_CASH_ADVANCE_KEY = exports.fetchGetFundingRequirementsIwocapay = exports.GET_FUNDING_REQUIREMENTS_IWOCAPAY_KEY = exports.fetchGetFundingRequirementsFlexi24 = exports.GET_FUNDING_REQUIREMENTS_FLEXI_24_KEY = exports.fetchGetFundingRequirementsCreditFacility = void 0;
exports.GET_IWOCAPAY_SHOPIFY_INSTALL_KEY = exports.fetchPostIwocapayShopifyGdprRetrieveCustomer = exports.POST_IWOCAPAY_SHOPIFY_GDPR_RETRIEVE_CUSTOMER_KEY = exports.fetchPostIwocapayShopifyGdprRedactShop = exports.POST_IWOCAPAY_SHOPIFY_GDPR_REDACT_SHOP_KEY = exports.fetchPostIwocapayShopifyGdprRedactCustomer = exports.POST_IWOCAPAY_SHOPIFY_GDPR_REDACT_CUSTOMER_KEY = exports.fetchPostIwocapaySellerOnboardingAnswers = exports.POST_IWOCAPAY_SELLER_ONBOARDING_ANSWERS_KEY = exports.fetchGetIwocapaySellerOnboardingAnswers = exports.GET_IWOCAPAY_SELLER_ONBOARDING_ANSWERS_KEY = exports.fetchGetIwocapaySellerSpendingLimitRequest = exports.GET_IWOCAPAY_SELLER_SPENDING_LIMIT_REQUEST_KEY = exports.fetchPostIwocapaySellerResendInvite = exports.POST_IWOCAPAY_SELLER_RESEND_INVITE_KEY = exports.fetchPutIwocapaySellerPaymentCapturedFund = exports.PUT_IWOCAPAY_SELLER_PAYMENT_CAPTURED_FUND_KEY = exports.fetchPutIwocapaySellerPaymentCapturedCancel = exports.PUT_IWOCAPAY_SELLER_PAYMENT_CAPTURED_CANCEL_KEY = exports.fetchPostIwocapaySellerEcommerceCredentials = exports.POST_IWOCAPAY_SELLER_ECOMMERCE_CREDENTIALS_KEY = exports.fetchGetIwocapaySellerEcommerceCredentials = exports.GET_IWOCAPAY_SELLER_ECOMMERCE_CREDENTIALS_KEY = exports.fetchGetIwocapaySellerConnection = exports.GET_IWOCAPAY_SELLER_CONNECTION_KEY = exports.fetchGetIwocapaySellerBranding = exports.GET_IWOCAPAY_SELLER_BRANDING_KEY = exports.fetchPostIwocapaySellerAccessUsers = exports.POST_IWOCAPAY_SELLER_ACCESS_USERS_KEY = exports.fetchGetIwocapaySellerAccessUsers = exports.GET_IWOCAPAY_SELLER_ACCESS_USERS_KEY = exports.fetchPutIwocapaySellerAccessUser = exports.PUT_IWOCAPAY_SELLER_ACCESS_USER_KEY = exports.fetchDeleteIwocapaySellerAccessUser = exports.DELETE_IWOCAPAY_SELLER_ACCESS_USER_KEY = exports.fetchGetIwocapayReferrer = exports.GET_IWOCAPAY_REFERRER_KEY = exports.fetchGetIwocapayReferrals = exports.GET_IWOCAPAY_REFERRALS_KEY = exports.fetchGetIwocapayReferral = exports.GET_IWOCAPAY_REFERRAL_KEY = exports.fetchPostIwocapayPaymentLater = exports.POST_IWOCAPAY_PAYMENT_LATER_KEY = exports.fetchGetIwocapayPaymentLater = exports.GET_IWOCAPAY_PAYMENT_LATER_KEY = exports.fetchGetIwocapayPaymentCaptured = exports.GET_IWOCAPAY_PAYMENT_CAPTURED_KEY = exports.fetchPostIwocapayPayLinkPackage = exports.POST_IWOCAPAY_PAY_LINK_PACKAGE_KEY = exports.fetchGetIwocapayPayLinkPackage = void 0;
exports.GET_ONLINE_ACCOUNT_KEY = exports.fetchPostOnfidoToken = exports.POST_ONFIDO_TOKEN_KEY = exports.fetchPostOnfidoStart = exports.POST_ONFIDO_START_KEY = exports.fetchPostOnfidoChecks = exports.POST_ONFIDO_CHECKS_KEY = exports.fetchPostOnfidoCheck = exports.POST_ONFIDO_CHECK_KEY = exports.fetchGetOnfidoCheck = exports.GET_ONFIDO_CHECK_KEY = exports.fetchPostOffersSelect = exports.POST_OFFERS_SELECT_KEY = exports.fetchGetMcaEstimatedSchedule = exports.GET_MCA_ESTIMATED_SCHEDULE_KEY = exports.fetchPostLogout = exports.POST_LOGOUT_KEY = exports.fetchGetLoginLink = exports.GET_LOGIN_LINK_KEY = exports.fetchGetLoanDocumentsUnsigned = exports.GET_LOAN_DOCUMENTS_UNSIGNED_KEY = exports.fetchGetLoanDocumentsSigned = exports.GET_LOAN_DOCUMENTS_SIGNED_KEY = exports.fetchPostLoanDocumentsSigned = exports.POST_LOAN_DOCUMENTS_SIGNED_KEY = exports.fetchGetLoanDocumentsRequiredRecoveryLoan = exports.GET_LOAN_DOCUMENTS_REQUIRED_RECOVERY_LOAN_KEY = exports.fetchGetLoanDocumentsRequiredMerchantCashAdvance = exports.GET_LOAN_DOCUMENTS_REQUIRED_MERCHANT_CASH_ADVANCE_KEY = exports.fetchGetLoanDocumentsRequiredIwocapay = exports.GET_LOAN_DOCUMENTS_REQUIRED_IWOCAPAY_KEY = exports.fetchGetLoanDocumentsRequiredFlexi24 = exports.GET_LOAN_DOCUMENTS_REQUIRED_FLEXI_24_KEY = exports.fetchGetLoanDocumentsRequiredCreditFacility = exports.GET_LOAN_DOCUMENTS_REQUIRED_CREDIT_FACILITY_KEY = exports.fetchGetLoanDocumentsRequiredCbils = exports.GET_LOAN_DOCUMENTS_REQUIRED_CBILS_KEY = exports.fetchGetLoanDocumentsRequiredBusinessLoan = exports.GET_LOAN_DOCUMENTS_REQUIRED_BUSINESS_LOAN_KEY = exports.fetchGetLoanDocuments = exports.GET_LOAN_DOCUMENTS_KEY = exports.fetchGetIwocapayShopifySellerShop = exports.GET_IWOCAPAY_SHOPIFY_SELLER_SHOP_KEY = exports.fetchGetIwocapayShopifyPostGrant = exports.GET_IWOCAPAY_SHOPIFY_POST_GRANT_KEY = exports.fetchPostIwocapayShopifyPaymentRefund = exports.POST_IWOCAPAY_SHOPIFY_PAYMENT_REFUND_KEY = exports.fetchPostIwocapayShopifyPayment = exports.POST_IWOCAPAY_SHOPIFY_PAYMENT_KEY = exports.fetchGetIwocapayShopifyInstall = void 0;
exports.POST_QUICKBOOKS_WEBHOOK_KEY = exports.fetchPostQuickbooksDisconnect = exports.POST_QUICKBOOKS_DISCONNECT_KEY = exports.fetchGetQuickbooksAuthorizationRedirect = exports.GET_QUICKBOOKS_AUTHORIZATION_REDIRECT_KEY = exports.fetchGetQuickbooksAuthorizationCallback = exports.GET_QUICKBOOKS_AUTHORIZATION_CALLBACK_KEY = exports.fetchGetProfile = exports.GET_PROFILE_KEY = exports.fetchGetProductOffers = exports.GET_PRODUCT_OFFERS_KEY = exports.fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation = exports.GET_PRODUCT_OFFERS_BY_RESTRICTED_EXTERNAL_DATA_SYNCS_AUTHORISATION_KEY = exports.fetchGetPostcodeLookup = exports.GET_POSTCODE_LOOKUP_KEY = exports.fetchPutPaymentMethod = exports.PUT_PAYMENT_METHOD_KEY = exports.fetchDeletePaymentMethod = exports.DELETE_PAYMENT_METHOD_KEY = exports.fetchPostPaymentMethod = exports.POST_PAYMENT_METHOD_KEY = exports.fetchGetPaymentMethod = exports.GET_PAYMENT_METHOD_KEY = exports.fetchPostPayLinkApplication = exports.POST_PAY_LINK_APPLICATION_KEY = exports.fetchGetPayLink = exports.GET_PAY_LINK_KEY = exports.fetchGetPayLinkGo = exports.GET_PAY_LINK_GO_KEY = exports.fetchPostPasswordlessEmailLogin = exports.POST_PASSWORDLESS_EMAIL_LOGIN_KEY = exports.fetchPostPasswordlessEmail = exports.POST_PASSWORDLESS_EMAIL_KEY = exports.fetchPostPasswordResetVerify = exports.POST_PASSWORD_RESET_VERIFY_KEY = exports.fetchPostPasswordResetSetPassword = exports.POST_PASSWORD_RESET_SET_PASSWORD_KEY = exports.fetchPostPasswordReset = exports.POST_PASSWORD_RESET_KEY = exports.fetchPostPasswordLogin = exports.POST_PASSWORD_LOGIN_KEY = exports.fetchPostPartnerDeveloper = exports.POST_PARTNER_DEVELOPER_KEY = exports.fetchGetPartnerBrokers = exports.GET_PARTNER_BROKERS_KEY = exports.fetchPostPageView = exports.POST_PAGE_VIEW_KEY = exports.fetchDeleteOnlineAccount = exports.DELETE_ONLINE_ACCOUNT_KEY = exports.fetchGetOnlineAccount = void 0;
exports.PUT_STATE_KEY = exports.fetchGetState = exports.GET_STATE_KEY = exports.fetchGetStateByStateKey = exports.GET_STATE_BY_STATE_KEY_KEY = exports.fetchPostState = exports.POST_STATE_KEY = exports.fetchGetSplitTest = exports.GET_SPLIT_TEST_KEY = exports.fetchGetSingleImmediatePayment = exports.GET_SINGLE_IMMEDIATE_PAYMENT_KEY = exports.fetchGetSignupBranding = exports.GET_SIGNUP_BRANDING_KEY = exports.fetchGetSellerOnboardingRequirements = exports.GET_SELLER_ONBOARDING_REQUIREMENTS_KEY = exports.fetchPutSellerAgreementDocumentSign = exports.PUT_SELLER_AGREEMENT_DOCUMENT_SIGN_KEY = exports.fetchGetSellerAgreementDocumentDownload = exports.GET_SELLER_AGREEMENT_DOCUMENT_DOWNLOAD_KEY = exports.fetchGetSellerAgreementDocument = exports.GET_SELLER_AGREEMENT_DOCUMENT_KEY = exports.fetchPostSellerIntegrationsRegisterInterest = exports.POST_SELLER_INTEGRATIONS_REGISTER_INTEREST_KEY = exports.fetchGetSellerIntegrationsRegisterInterest = exports.GET_SELLER_INTEGRATIONS_REGISTER_INTEREST_KEY = exports.fetchPostSellerHandle = exports.POST_SELLER_HANDLE_KEY = exports.fetchPutSellerEnabledProducts = exports.PUT_SELLER_ENABLED_PRODUCTS_KEY = exports.fetchGetSellerEnabledProducts = exports.GET_SELLER_ENABLED_PRODUCTS_KEY = exports.fetchPostSeller = exports.POST_SELLER_KEY = exports.fetchGetSeller = exports.GET_SELLER_KEY = exports.fetchGetSellerHandleAvailability = exports.GET_SELLER_HANDLE_AVAILABILITY_KEY = exports.fetchGetSellerHandle = exports.GET_SELLER_HANDLE_KEY = exports.fetchGetSelectPaymentProcessor = exports.GET_SELECT_PAYMENT_PROCESSOR_KEY = exports.fetchPostRepaymentRegisterRepaymentMethod = exports.POST_REPAYMENT_REGISTER_REPAYMENT_METHOD_KEY = exports.fetchPostRepaymentPaymentMethod = exports.POST_REPAYMENT_PAYMENT_METHOD_KEY = exports.fetchGetRepaymentPaymentMethod = exports.GET_REPAYMENT_PAYMENT_METHOD_KEY = exports.fetchPostRepaymentPaymentIntent = exports.POST_REPAYMENT_PAYMENT_INTENT_KEY = exports.fetchPostQuickbooksWebhook = void 0;
exports.fetchPutXeroOrganisationAccount = exports.PUT_XERO_ORGANISATION_ACCOUNT_KEY = exports.fetchPostXeroOrganisationAccount = exports.POST_XERO_ORGANISATION_ACCOUNT_KEY = exports.fetchGetXeroOrganisationAccount = exports.GET_XERO_ORGANISATION_ACCOUNT_KEY = exports.fetchPostXeroLogin = exports.POST_XERO_LOGIN_KEY = exports.fetchGetXeroLogin = exports.GET_XERO_LOGIN_KEY = exports.fetchPostXeroIwocapaySellerBrandingThemesPaymentServices = exports.POST_XERO_IWOCAPAY_SELLER_BRANDING_THEMES_PAYMENT_SERVICES_KEY = exports.fetchGetXeroIwocapaySellerBrandingThemes = exports.GET_XERO_IWOCAPAY_SELLER_BRANDING_THEMES_KEY = exports.fetchPutXeroIwocapaySellerAccount = exports.PUT_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = exports.fetchPostXeroIwocapaySellerAccount = exports.POST_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = exports.fetchGetXeroIwocapaySellerAccount = exports.GET_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = exports.fetchGetXeroConnections = exports.GET_XERO_CONNECTIONS_KEY = exports.fetchDeleteXeroConnections = exports.DELETE_XERO_CONNECTIONS_KEY = exports.fetchPostXeroConnect = exports.POST_XERO_CONNECT_KEY = exports.fetchGetXeroCallback = exports.GET_XERO_CALLBACK_KEY = exports.fetchGetXeroAccounts = exports.GET_XERO_ACCOUNTS_KEY = exports.fetchPostTwoFactorSetup = exports.POST_TWO_FACTOR_SETUP_KEY = exports.fetchGetTwoFactorSetup = exports.GET_TWO_FACTOR_SETUP_KEY = exports.fetchPostTwoFactorAuthenticate = exports.POST_TWO_FACTOR_AUTHENTICATE_KEY = exports.fetchGetTruelayerPayment = exports.GET_TRUELAYER_PAYMENT_KEY = exports.fetchPostTruelayerBankAuthenticationUrl = exports.POST_TRUELAYER_BANK_AUTHENTICATION_URL_KEY = exports.fetchPostTruelayerAuthorizationUrl = exports.POST_TRUELAYER_AUTHORIZATION_URL_KEY = exports.fetchPutThreatmetrixEvent = exports.PUT_THREATMETRIX_EVENT_KEY = exports.fetchPostThreatmetrixEvent = exports.POST_THREATMETRIX_EVENT_KEY = exports.fetchGetStatements = exports.GET_STATEMENTS_KEY = exports.fetchPutState = void 0;
const lendingAPI_1 = require("./lendingAPI");
var lendingAPI_2 = require("./lendingAPI");
Object.defineProperty(exports, "fetchLendingAPI", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPI; } });
Object.defineProperty(exports, "fetchLendingAPIJSON", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPIJSON; } });
Object.defineProperty(exports, "LapiError", { enumerable: true, get: function () { return lendingAPI_2.LapiError; } });
exports.GET_ACCOUNTS_KEY = "getAccounts";
/**
 * TBD
 */
function fetchGetAccounts({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/accounts/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetAccounts = fetchGetAccounts;
exports.POST_ANONYMISED_DATA_EVALUATION_KEY = "postAnonymisedDataEvaluation";
/**
 * Evaluation of anonymised data to determine estimations of approval characteristics.
 */
function fetchPostAnonymisedDataEvaluation({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/anonymised_data_evaluation/`, {
        method: "post",
        body,
    });
}
exports.fetchPostAnonymisedDataEvaluation = fetchPostAnonymisedDataEvaluation;
exports.GET_APPLICATION_KEY = "getApplication";
/**
 * TBD
 */
function fetchGetApplication({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/application/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetApplication = fetchGetApplication;
exports.POST_APPLICATION_KEY = "postApplication";
/**
 * Create user application. If valid introducer_uuid id is provided, Application will be assigned to him
 */
function fetchPostApplication({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/application/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApplication = fetchPostApplication;
exports.PUT_APPLICATION_KEY = "putApplication";
/**
 * Update user application. If valid introducer_uuid id is provided, Application will be assigned to him
 */
function fetchPutApplication({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/application/${stateKey}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutApplication = fetchPutApplication;
exports.GET_APPLICATION_CUSTOMER_CONFIRMED_PROVIDING_DOCS_KEY = "getApplicationCustomerConfirmedProvidingDocs";
/**
 * For the current open application, get the status and timestamp of latest customer_confirmed_providing_docs event
 */
function fetchGetApplicationCustomerConfirmedProvidingDocs({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/application/${stateKey}/customer_confirmed_providing_docs/`, {
        method: "get",
    });
}
exports.fetchGetApplicationCustomerConfirmedProvidingDocs = fetchGetApplicationCustomerConfirmedProvidingDocs;
exports.POST_APPLICATION_CUSTOMER_CONFIRMED_PROVIDING_DOCS_KEY = "postApplicationCustomerConfirmedProvidingDocs";
/**
 * For the current open application, set the status and timestamp of latest customer_confirmed_providing_docs event
 */
function fetchPostApplicationCustomerConfirmedProvidingDocs({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/application/${stateKey}/customer_confirmed_providing_docs/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApplicationCustomerConfirmedProvidingDocs = fetchPostApplicationCustomerConfirmedProvidingDocs;
exports.POST_APPLICATION_DECLINE_KEY = "postApplicationDecline";
/**
 * TBD
 */
function fetchPostApplicationDecline({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/application/${stateKey}/decline/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApplicationDecline = fetchPostApplicationDecline;
exports.POST_APPLICATION_DEFER_KEY = "postApplicationDefer";
/**
 * TBD
 */
function fetchPostApplicationDefer({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/application/${stateKey}/defer/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApplicationDefer = fetchPostApplicationDefer;
exports.POST_APPLICATION_REFRESH_KEY = "postApplicationRefresh";
/**
 * Create refreshed application and immediately formalise any appropriate offers
 */
function fetchPostApplicationRefresh({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/application/${stateKey}/refresh/`, {
        method: "post",
        body,
    });
}
exports.fetchPostApplicationRefresh = fetchPostApplicationRefresh;
exports.GET_APPLICATIONS_OFFERS_KEY = "getApplicationsOffers";
/**
 * No description
 */
function fetchGetApplicationsOffers({ applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/applications/${applicationId}/offers/`, {
        method: "get",
    });
}
exports.fetchGetApplicationsOffers = fetchGetApplicationsOffers;
exports.GET_ASSOCIATED_PEOPLE_KEY = "getAssociatedPeople";
/**
 * Retrieve the people associated with the company on the application.
 */
function fetchGetAssociatedPeople({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/associated_people/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetAssociatedPeople = fetchGetAssociatedPeople;
exports.GET_COMPANY_SEARCH_KEY = "getCompanySearch";
/**
 * No description
 */
function fetchGetCompanySearch({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/company_search/`, {
        method: "get",
        query,
    });
}
exports.fetchGetCompanySearch = fetchGetCompanySearch;
exports.GET_CONTEXT_BY_STATE_KEY_KEY = "getContextByStateKey";
/**
 * Collection of attributes to operate with iwoca&#x27;s lending API.
 */
function fetchGetContextByStateKey({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/context/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetContextByStateKey = fetchGetContextByStateKey;
exports.GET_CONTEXT_KEY = "getContext";
/**
 * Collection of attributes to operate with iwoca&#x27;s lending API.
 */
function fetchGetContext({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/context/`, {
        method: "get",
    });
}
exports.fetchGetContext = fetchGetContext;
exports.GET_DIRECTOR_SEARCH_KEY = "getDirectorSearch";
/**
 * No description
 */
function fetchGetDirectorSearch({ companyNumber, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/director_search/${companyNumber}/`, {
        method: "get",
    });
}
exports.fetchGetDirectorSearch = fetchGetDirectorSearch;
exports.GET_DOCUMENT_FEEDBACK_KEY = "getDocumentFeedback";
/**
 * No description
 */
function fetchGetDocumentFeedback({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/document_feedback/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetDocumentFeedback = fetchGetDocumentFeedback;
exports.GET_DOCUMENT_UPLOAD_KEY = "getDocumentUpload";
/**
 * No description
 */
function fetchGetDocumentUpload({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/document_upload/${stateKey}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetDocumentUpload = fetchGetDocumentUpload;
exports.POST_DOCUMENT_UPLOAD_KEY = "postDocumentUpload";
/**
 * No description
 */
function fetchPostDocumentUpload({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/document_upload/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostDocumentUpload = fetchPostDocumentUpload;
exports.PUT_DOCUMENT_UPLOAD_KEY = "putDocumentUpload";
/**
 * No description
 */
function fetchPutDocumentUpload({ stateKey, documentId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/document_upload/${stateKey}/${documentId}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutDocumentUpload = fetchPutDocumentUpload;
exports.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_CREDIT_FACILITY_KEY = "getDrawDownRepaymentScheduleCreditFacility";
/**
 * Returns the simulated repayment schedule for the given formal offer id as if the customer was completing a funding today. This can be used when a customer has not yet draw down and wants to see possible repayment schedules before they commit to a loan. After one or more offers are formalised, the logic allows the customer (or a staff member) to simulate the conditions of the loan within the constraints of the formal offer. For example, they can vary the loan amount and see how the repayment schedule changes, along with total cost, repayment amount, fee, interest rate, etc. The requester can also simulate an early final repayment date and see how much it would reduce the total cost by repaying the loan earlier.
 */
function fetchGetDrawDownRepaymentScheduleCreditFacility({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/draw_down_repayment_schedule/${stateKey}/credit_facility/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetDrawDownRepaymentScheduleCreditFacility = fetchGetDrawDownRepaymentScheduleCreditFacility;
exports.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_FLEXI_24_KEY = "getDrawDownRepaymentScheduleFlexi24";
/**
 * Returns the simulated repayment schedule for the given formal offer id as if the customer was completing a funding today. This can be used when a customer has not yet draw down and wants to see possible repayment schedules before they commit to a loan. After one or more offers are formalised, the logic allows the customer (or a staff member) to simulate the conditions of the loan within the constraints of the formal offer. For example, they can vary the loan amount and see how the repayment schedule changes, along with total cost, repayment amount, fee, interest rate, etc. The requester can also simulate an early final repayment date and see how much it would reduce the total cost by repaying the loan earlier.
 */
function fetchGetDrawDownRepaymentScheduleFlexi24({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/draw_down_repayment_schedule/${stateKey}/flexi24/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetDrawDownRepaymentScheduleFlexi24 = fetchGetDrawDownRepaymentScheduleFlexi24;
exports.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_IWOCAPAY_KEY = "getDrawDownRepaymentScheduleIwocapay";
/**
 * Returns the simulated repayment schedule for the given formal offer id as if the customer was completing a funding today. This can be used when a customer has not yet draw down and wants to see the repayment schedule. After one or more offers are formalised, the logic allows the customer (or a staff member) to simulate the conditions of the loan within the constraints of the formal offer. The requester can also simulate an early final repayment date and see how much it would reduce the total cost by repaying the loan earlier.
 */
function fetchGetDrawDownRepaymentScheduleIwocapay({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/draw_down_repayment_schedule/${stateKey}/iwocapay/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetDrawDownRepaymentScheduleIwocapay = fetchGetDrawDownRepaymentScheduleIwocapay;
exports.GET_DRAW_DOWN_REPAYMENT_SCHEDULE_RECOVERY_LOAN_KEY = "getDrawDownRepaymentScheduleRecoveryLoan";
/**
 * Returns the simulated repayment schedule for the given formal offer id as if the customer was completing a funding today. This can be used when a customer has not yet draw down and wants to see possible repayment schedules before they commit to a loan. After one or more offers are formalised, the logic allows the customer (or a staff member) to simulate the conditions of the loan within the constraints of the formal offer. For example, they can vary the loan amount and see how the repayment schedule changes, along with total cost, repayment amount, fee, interest rate, etc. The requester can also simulate an early final repayment date and see how much it would reduce the total cost by repaying the loan earlier.
 */
function fetchGetDrawDownRepaymentScheduleRecoveryLoan({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/draw_down_repayment_schedule/${stateKey}/recovery_loan/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetDrawDownRepaymentScheduleRecoveryLoan = fetchGetDrawDownRepaymentScheduleRecoveryLoan;
exports.GET_EARLY_REPAYMENT_SIMULATION_KEY = "getEarlyRepaymentSimulation";
/**
 * When the customer already has an account it returns the simulated repayment schedule for the given account where an early repayment of the given amount was made at the time of the request.For example, they can vary the loan amount and see how the repayment schedule changes, along with total cost, repayment amount, fee, interest rate, etc.
 */
function fetchGetEarlyRepaymentSimulation({ stateKey, accountId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/early_repayment_simulation/${stateKey}/${accountId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetEarlyRepaymentSimulation = fetchGetEarlyRepaymentSimulation;
exports.POST_EARLY_REPAYMENT_TRUELAYER_KEY = "postEarlyRepaymentTruelayer";
/**
 * Creates an early repayment via Truelayer and redirects the customer to Truelayer&#x27;s Hosted Payment Page
 */
function fetchPostEarlyRepaymentTruelayer({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/early_repayment_truelayer/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostEarlyRepaymentTruelayer = fetchPostEarlyRepaymentTruelayer;
exports.DELETE_ECOMMERCE_ORDER_KEY = "deleteEcommerceOrder";
/**
 * No description
 */
function fetchDeleteEcommerceOrder({ orderId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/ecommerce/order/${orderId}/`, {
        method: "delete",
        body,
    });
}
exports.fetchDeleteEcommerceOrder = fetchDeleteEcommerceOrder;
exports.GET_ECOMMERCE_ORDER_KEY = "getEcommerceOrder";
/**
 * No description
 */
function fetchGetEcommerceOrder({ orderId }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/ecommerce/order/${orderId}/`, {
        method: "get",
    });
}
exports.fetchGetEcommerceOrder = fetchGetEcommerceOrder;
exports.POST_ECOMMERCE_SELLER_ORDER_KEY = "postEcommerceSellerOrder";
/**
 * No description
 */
function fetchPostEcommerceSellerOrder({ sellerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/ecommerce/seller/${sellerId}/order/`, {
        method: "post",
        body,
    });
}
exports.fetchPostEcommerceSellerOrder = fetchPostEcommerceSellerOrder;
exports.GET_EMAIL_AVAILABILITY_KEY = "getEmailAvailability";
/**
 * No description
 */
function fetchGetEmailAvailability({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/email_availability/`, {
        method: "get",
        query,
    });
}
exports.fetchGetEmailAvailability = fetchGetEmailAvailability;
exports.GET_EXAMPLE_REPAYMENT_SCHEDULE_KEY = "getExampleRepaymentSchedule";
/**
 * No description
 */
function fetchGetExampleRepaymentSchedule({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/example_repayment_schedule/`, {
        method: "get",
        query,
    });
}
exports.fetchGetExampleRepaymentSchedule = fetchGetExampleRepaymentSchedule;
exports.GET_FORMAL_INDICATIVE_OFFERS_KEY = "getFormalIndicativeOffers";
/**
 * No description
 */
function fetchGetFormalIndicativeOffers({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_indicative_offers/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetFormalIndicativeOffers = fetchGetFormalIndicativeOffers;
exports.POST_FORMAL_INDICATIVE_OFFERS_KEY = "postFormalIndicativeOffers";
/**
 * Create formal indicative offers
 */
function fetchPostFormalIndicativeOffers({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_indicative_offers/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalIndicativeOffers = fetchPostFormalIndicativeOffers;
exports.GET_FORMAL_OFFERS_KEY = "getFormalOffers";
/**
 * No description
 */
function fetchGetFormalOffers({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetFormalOffers = fetchGetFormalOffers;
exports.POST_FORMAL_OFFERS_KEY = "postFormalOffers";
/**
 * No description
 */
function fetchPostFormalOffers({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalOffers = fetchPostFormalOffers;
exports.GET_FORMAL_OFFERS_BUSINESS_LOAN_COMMISSION_CONSENT_KEY = "getFormalOffersBusinessLoanCommissionConsent";
/**
 * No description
 */
function fetchGetFormalOffersBusinessLoanCommissionConsent({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/business_loan/${offerId}/commission_consent/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFormalOffersBusinessLoanCommissionConsent = fetchGetFormalOffersBusinessLoanCommissionConsent;
exports.POST_FORMAL_OFFERS_BUSINESS_LOAN_COMMISSION_CONSENT_KEY = "postFormalOffersBusinessLoanCommissionConsent";
/**
 * No description
 */
function fetchPostFormalOffersBusinessLoanCommissionConsent({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/business_loan/${offerId}/commission_consent/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalOffersBusinessLoanCommissionConsent = fetchPostFormalOffersBusinessLoanCommissionConsent;
exports.GET_FORMAL_OFFERS_BUSINESS_LOAN_CONFIGURATION_KEY = "getFormalOffersBusinessLoanConfiguration";
/**
 * Get the parameters the customer anticipates using for a business_loan offer at drawdown.
 */
function fetchGetFormalOffersBusinessLoanConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/business_loan/${offerId}/configuration/`, {
        method: "get",
    });
}
exports.fetchGetFormalOffersBusinessLoanConfiguration = fetchGetFormalOffersBusinessLoanConfiguration;
exports.PUT_FORMAL_OFFERS_BUSINESS_LOAN_CONFIGURATION_KEY = "putFormalOffersBusinessLoanConfiguration";
/**
 * Update the parameters teh customer anticipates using for a business_loan offer at drawdown.
 */
function fetchPutFormalOffersBusinessLoanConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/business_loan/${offerId}/configuration/`, {
        method: "put",
        body,
    });
}
exports.fetchPutFormalOffersBusinessLoanConfiguration = fetchPutFormalOffersBusinessLoanConfiguration;
exports.GET_FORMAL_OFFERS_CBILS_COMMISSION_CONSENT_KEY = "getFormalOffersCbilsCommissionConsent";
/**
 * No description
 */
function fetchGetFormalOffersCbilsCommissionConsent({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/cbils/${offerId}/commission_consent/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFormalOffersCbilsCommissionConsent = fetchGetFormalOffersCbilsCommissionConsent;
exports.POST_FORMAL_OFFERS_CBILS_COMMISSION_CONSENT_KEY = "postFormalOffersCbilsCommissionConsent";
/**
 * No description
 */
function fetchPostFormalOffersCbilsCommissionConsent({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/cbils/${offerId}/commission_consent/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalOffersCbilsCommissionConsent = fetchPostFormalOffersCbilsCommissionConsent;
exports.GET_FORMAL_OFFERS_CBILS_CONFIGURATION_KEY = "getFormalOffersCbilsConfiguration";
/**
 * Get the parameters the customer anticipates using for a cbils offer at drawdown.
 */
function fetchGetFormalOffersCbilsConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/cbils/${offerId}/configuration/`, {
        method: "get",
    });
}
exports.fetchGetFormalOffersCbilsConfiguration = fetchGetFormalOffersCbilsConfiguration;
exports.PUT_FORMAL_OFFERS_CBILS_CONFIGURATION_KEY = "putFormalOffersCbilsConfiguration";
/**
 * Update the parameters teh customer anticipates using for a cbils offer at drawdown.
 */
function fetchPutFormalOffersCbilsConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/cbils/${offerId}/configuration/`, {
        method: "put",
        body,
    });
}
exports.fetchPutFormalOffersCbilsConfiguration = fetchPutFormalOffersCbilsConfiguration;
exports.GET_FORMAL_OFFERS_CREDIT_FACILITY_COMMISSION_CONSENT_KEY = "getFormalOffersCreditFacilityCommissionConsent";
/**
 * No description
 */
function fetchGetFormalOffersCreditFacilityCommissionConsent({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/credit_facility/${offerId}/commission_consent/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFormalOffersCreditFacilityCommissionConsent = fetchGetFormalOffersCreditFacilityCommissionConsent;
exports.POST_FORMAL_OFFERS_CREDIT_FACILITY_COMMISSION_CONSENT_KEY = "postFormalOffersCreditFacilityCommissionConsent";
/**
 * No description
 */
function fetchPostFormalOffersCreditFacilityCommissionConsent({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/credit_facility/${offerId}/commission_consent/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalOffersCreditFacilityCommissionConsent = fetchPostFormalOffersCreditFacilityCommissionConsent;
exports.GET_FORMAL_OFFERS_CREDIT_FACILITY_CONFIGURATION_KEY = "getFormalOffersCreditFacilityConfiguration";
/**
 * Get the parameters the customer anticipates using for a credit_facility offer at drawdown.
 */
function fetchGetFormalOffersCreditFacilityConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/credit_facility/${offerId}/configuration/`, {
        method: "get",
    });
}
exports.fetchGetFormalOffersCreditFacilityConfiguration = fetchGetFormalOffersCreditFacilityConfiguration;
exports.PUT_FORMAL_OFFERS_CREDIT_FACILITY_CONFIGURATION_KEY = "putFormalOffersCreditFacilityConfiguration";
/**
 * Update the parameters teh customer anticipates using for a credit_facility offer at drawdown.
 */
function fetchPutFormalOffersCreditFacilityConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/credit_facility/${offerId}/configuration/`, {
        method: "put",
        body,
    });
}
exports.fetchPutFormalOffersCreditFacilityConfiguration = fetchPutFormalOffersCreditFacilityConfiguration;
exports.GET_FORMAL_OFFERS_FLEXI_24_COMMISSION_CONSENT_KEY = "getFormalOffersFlexi24CommissionConsent";
/**
 * No description
 */
function fetchGetFormalOffersFlexi24CommissionConsent({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/flexi24/${offerId}/commission_consent/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFormalOffersFlexi24CommissionConsent = fetchGetFormalOffersFlexi24CommissionConsent;
exports.POST_FORMAL_OFFERS_FLEXI_24_COMMISSION_CONSENT_KEY = "postFormalOffersFlexi24CommissionConsent";
/**
 * No description
 */
function fetchPostFormalOffersFlexi24CommissionConsent({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/flexi24/${offerId}/commission_consent/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalOffersFlexi24CommissionConsent = fetchPostFormalOffersFlexi24CommissionConsent;
exports.GET_FORMAL_OFFERS_FLEXI_24_CONFIGURATION_KEY = "getFormalOffersFlexi24Configuration";
/**
 * Get the parameters the customer anticipates using for a flexi24 offer at drawdown.
 */
function fetchGetFormalOffersFlexi24Configuration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/flexi24/${offerId}/configuration/`, {
        method: "get",
    });
}
exports.fetchGetFormalOffersFlexi24Configuration = fetchGetFormalOffersFlexi24Configuration;
exports.PUT_FORMAL_OFFERS_FLEXI_24_CONFIGURATION_KEY = "putFormalOffersFlexi24Configuration";
/**
 * Update the parameters teh customer anticipates using for a flexi24 offer at drawdown.
 */
function fetchPutFormalOffersFlexi24Configuration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/flexi24/${offerId}/configuration/`, {
        method: "put",
        body,
    });
}
exports.fetchPutFormalOffersFlexi24Configuration = fetchPutFormalOffersFlexi24Configuration;
exports.GET_FORMAL_OFFERS_IWOCAPAY_COMMISSION_CONSENT_KEY = "getFormalOffersIwocapayCommissionConsent";
/**
 * No description
 */
function fetchGetFormalOffersIwocapayCommissionConsent({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/iwocapay/${offerId}/commission_consent/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFormalOffersIwocapayCommissionConsent = fetchGetFormalOffersIwocapayCommissionConsent;
exports.POST_FORMAL_OFFERS_IWOCAPAY_COMMISSION_CONSENT_KEY = "postFormalOffersIwocapayCommissionConsent";
/**
 * No description
 */
function fetchPostFormalOffersIwocapayCommissionConsent({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/iwocapay/${offerId}/commission_consent/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalOffersIwocapayCommissionConsent = fetchPostFormalOffersIwocapayCommissionConsent;
exports.GET_FORMAL_OFFERS_IWOCAPAY_CONFIGURATION_KEY = "getFormalOffersIwocapayConfiguration";
/**
 * Get the parameters the customer anticipates using for a iwocapay offer at drawdown.
 */
function fetchGetFormalOffersIwocapayConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/iwocapay/${offerId}/configuration/`, {
        method: "get",
    });
}
exports.fetchGetFormalOffersIwocapayConfiguration = fetchGetFormalOffersIwocapayConfiguration;
exports.PUT_FORMAL_OFFERS_IWOCAPAY_CONFIGURATION_KEY = "putFormalOffersIwocapayConfiguration";
/**
 * Update the parameters teh customer anticipates using for a iwocapay offer at drawdown.
 */
function fetchPutFormalOffersIwocapayConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/iwocapay/${offerId}/configuration/`, {
        method: "put",
        body,
    });
}
exports.fetchPutFormalOffersIwocapayConfiguration = fetchPutFormalOffersIwocapayConfiguration;
exports.GET_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_COMMISSION_CONSENT_KEY = "getFormalOffersMerchantCashAdvanceCommissionConsent";
/**
 * No description
 */
function fetchGetFormalOffersMerchantCashAdvanceCommissionConsent({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/commission_consent/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFormalOffersMerchantCashAdvanceCommissionConsent = fetchGetFormalOffersMerchantCashAdvanceCommissionConsent;
exports.POST_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_COMMISSION_CONSENT_KEY = "postFormalOffersMerchantCashAdvanceCommissionConsent";
/**
 * No description
 */
function fetchPostFormalOffersMerchantCashAdvanceCommissionConsent({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/commission_consent/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalOffersMerchantCashAdvanceCommissionConsent = fetchPostFormalOffersMerchantCashAdvanceCommissionConsent;
exports.GET_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_CONFIGURATION_KEY = "getFormalOffersMerchantCashAdvanceConfiguration";
/**
 * Get the parameters the customer anticipates using for a merchant_cash_advance offer at drawdown.
 */
function fetchGetFormalOffersMerchantCashAdvanceConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/configuration/`, {
        method: "get",
    });
}
exports.fetchGetFormalOffersMerchantCashAdvanceConfiguration = fetchGetFormalOffersMerchantCashAdvanceConfiguration;
exports.PUT_FORMAL_OFFERS_MERCHANT_CASH_ADVANCE_CONFIGURATION_KEY = "putFormalOffersMerchantCashAdvanceConfiguration";
/**
 * Update the parameters teh customer anticipates using for a merchant_cash_advance offer at drawdown.
 */
function fetchPutFormalOffersMerchantCashAdvanceConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/merchant_cash_advance/${offerId}/configuration/`, {
        method: "put",
        body,
    });
}
exports.fetchPutFormalOffersMerchantCashAdvanceConfiguration = fetchPutFormalOffersMerchantCashAdvanceConfiguration;
exports.GET_FORMAL_OFFERS_RECOVERY_LOAN_COMMISSION_CONSENT_KEY = "getFormalOffersRecoveryLoanCommissionConsent";
/**
 * No description
 */
function fetchGetFormalOffersRecoveryLoanCommissionConsent({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/recovery_loan/${offerId}/commission_consent/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFormalOffersRecoveryLoanCommissionConsent = fetchGetFormalOffersRecoveryLoanCommissionConsent;
exports.POST_FORMAL_OFFERS_RECOVERY_LOAN_COMMISSION_CONSENT_KEY = "postFormalOffersRecoveryLoanCommissionConsent";
/**
 * No description
 */
function fetchPostFormalOffersRecoveryLoanCommissionConsent({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/recovery_loan/${offerId}/commission_consent/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFormalOffersRecoveryLoanCommissionConsent = fetchPostFormalOffersRecoveryLoanCommissionConsent;
exports.GET_FORMAL_OFFERS_RECOVERY_LOAN_CONFIGURATION_KEY = "getFormalOffersRecoveryLoanConfiguration";
/**
 * Get the parameters the customer anticipates using for a recovery_loan offer at drawdown.
 */
function fetchGetFormalOffersRecoveryLoanConfiguration({ stateKey, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/formal_offers/${stateKey}/recovery_loan/${offerId}/configuration/`, {
        method: "get",
    });
}
exports.fetchGetFormalOffersRecoveryLoanConfiguration = fetchGetFormalOffersRecoveryLoanConfiguration;
exports.PUT_FORMAL_OFFERS_RECOVERY_LOAN_CONFIGURATION_KEY = "putFormalOffersRecoveryLoanConfiguration";
/**
 * Update the parameters teh customer anticipates using for a recovery_loan offer at drawdown.
 */
function fetchPutFormalOffersRecoveryLoanConfiguration({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/formal_offers/${stateKey}/recovery_loan/${offerId}/configuration/`, {
        method: "put",
        body,
    });
}
exports.fetchPutFormalOffersRecoveryLoanConfiguration = fetchPutFormalOffersRecoveryLoanConfiguration;
exports.POST_FUND_SELLER_REQUEST_KEY = "postFundSellerRequest";
/**
 * No description
 */
function fetchPostFundSellerRequest({ stateKey, offerId, payLinkId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/fund_seller_request/${stateKey}/${offerId}/${payLinkId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFundSellerRequest = fetchPostFundSellerRequest;
exports.POST_FUNDING_REQUEST_BUSINESS_LOAN_KEY = "postFundingRequestBusinessLoan";
/**
 * No description
 */
function fetchPostFundingRequestBusinessLoan({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/funding_request/${stateKey}/business_loan/${offerId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFundingRequestBusinessLoan = fetchPostFundingRequestBusinessLoan;
exports.POST_FUNDING_REQUEST_CBILS_KEY = "postFundingRequestCbils";
/**
 * No description
 */
function fetchPostFundingRequestCbils({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/funding_request/${stateKey}/cbils/${offerId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFundingRequestCbils = fetchPostFundingRequestCbils;
exports.POST_FUNDING_REQUEST_CREDIT_FACILITY_KEY = "postFundingRequestCreditFacility";
/**
 * No description
 */
function fetchPostFundingRequestCreditFacility({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/funding_request/${stateKey}/credit_facility/${offerId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFundingRequestCreditFacility = fetchPostFundingRequestCreditFacility;
exports.POST_FUNDING_REQUEST_FLEXI_24_KEY = "postFundingRequestFlexi24";
/**
 * No description
 */
function fetchPostFundingRequestFlexi24({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/funding_request/${stateKey}/flexi24/${offerId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFundingRequestFlexi24 = fetchPostFundingRequestFlexi24;
exports.POST_FUNDING_REQUEST_IWOCAPAY_KEY = "postFundingRequestIwocapay";
/**
 * No description
 */
function fetchPostFundingRequestIwocapay({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/funding_request/${stateKey}/iwocapay/${offerId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFundingRequestIwocapay = fetchPostFundingRequestIwocapay;
exports.POST_FUNDING_REQUEST_MERCHANT_CASH_ADVANCE_KEY = "postFundingRequestMerchantCashAdvance";
/**
 * No description
 */
function fetchPostFundingRequestMerchantCashAdvance({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/funding_request/${stateKey}/merchant_cash_advance/${offerId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFundingRequestMerchantCashAdvance = fetchPostFundingRequestMerchantCashAdvance;
exports.POST_FUNDING_REQUEST_RECOVERY_LOAN_KEY = "postFundingRequestRecoveryLoan";
/**
 * No description
 */
function fetchPostFundingRequestRecoveryLoan({ stateKey, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/funding_request/${stateKey}/recovery_loan/${offerId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostFundingRequestRecoveryLoan = fetchPostFundingRequestRecoveryLoan;
exports.GET_FUNDING_REQUIREMENTS_BUSINESS_LOAN_KEY = "getFundingRequirementsBusinessLoan";
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsBusinessLoan({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${stateKey}/business_loan/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFundingRequirementsBusinessLoan = fetchGetFundingRequirementsBusinessLoan;
exports.GET_FUNDING_REQUIREMENTS_CBILS_KEY = "getFundingRequirementsCbils";
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsCbils({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${stateKey}/cbils/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFundingRequirementsCbils = fetchGetFundingRequirementsCbils;
exports.GET_FUNDING_REQUIREMENTS_CREDIT_FACILITY_KEY = "getFundingRequirementsCreditFacility";
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsCreditFacility({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${stateKey}/credit_facility/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFundingRequirementsCreditFacility = fetchGetFundingRequirementsCreditFacility;
exports.GET_FUNDING_REQUIREMENTS_FLEXI_24_KEY = "getFundingRequirementsFlexi24";
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsFlexi24({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${stateKey}/flexi24/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFundingRequirementsFlexi24 = fetchGetFundingRequirementsFlexi24;
exports.GET_FUNDING_REQUIREMENTS_IWOCAPAY_KEY = "getFundingRequirementsIwocapay";
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsIwocapay({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${stateKey}/iwocapay/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFundingRequirementsIwocapay = fetchGetFundingRequirementsIwocapay;
exports.GET_FUNDING_REQUIREMENTS_MERCHANT_CASH_ADVANCE_KEY = "getFundingRequirementsMerchantCashAdvance";
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsMerchantCashAdvance({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${stateKey}/merchant_cash_advance/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFundingRequirementsMerchantCashAdvance = fetchGetFundingRequirementsMerchantCashAdvance;
exports.GET_FUNDING_REQUIREMENTS_RECOVERY_LOAN_KEY = "getFundingRequirementsRecoveryLoan";
/**
 * To accurately return the
funding requirements that are checked on funding, all available
url parameters should be provided.

If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetFundingRequirementsRecoveryLoan({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/funding_requirements/${stateKey}/recovery_loan/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetFundingRequirementsRecoveryLoan = fetchGetFundingRequirementsRecoveryLoan;
exports.POST_INTRODUCER_KEY = "postIntroducer";
/**
 * Create an introducer
 */
function fetchPostIntroducer({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIntroducer = fetchPostIntroducer;
exports.GET_INTRODUCER_REPAYMENT_SIMULATOR_KEY = "getIntroducerRepaymentSimulator";
/**
 * No description
 */
function fetchGetIntroducerRepaymentSimulator({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/repayment_simulator/`, {
        method: "get",
        query,
    });
}
exports.fetchGetIntroducerRepaymentSimulator = fetchGetIntroducerRepaymentSimulator;
exports.GET_INTRODUCER_KEY = "getIntroducer";
/**
 * Get the current introducer
 */
function fetchGetIntroducer({ introducerId }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${introducerId}/`, {
        method: "get",
    });
}
exports.fetchGetIntroducer = fetchGetIntroducer;
exports.GET_INTRODUCER_APPLICATION_KEY = "getIntroducerApplication";
/**
 * No description
 */
function fetchGetIntroducerApplication({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${introducerId}/application/${applicationId}/`, {
        method: "get",
    });
}
exports.fetchGetIntroducerApplication = fetchGetIntroducerApplication;
exports.GET_INTRODUCER_APPLICATION_OFFER_ALLOWED_WITHDRAWAL_FEE_RATES_KEY = "getIntroducerApplicationOfferAllowedWithdrawalFeeRates";
/**
 * No description
 */
function fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/allowed_withdrawal_fee_rates/`, {
        method: "get",
    });
}
exports.fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates = fetchGetIntroducerApplicationOfferAllowedWithdrawalFeeRates;
exports.PUT_INTRODUCER_APPLICATION_OFFER_ENTITY_TO_CONTACT_KEY = "putIntroducerApplicationOfferEntityToContact";
/**
 * Updates the entity_to_contact for a formal offer. Used by introducers to accept or reject a formal offer on their client&#x27;s behalf from within the portal. Optionally, how and when to contact the client can be suggested if setting the contact entity to customer.
 */
function fetchPutIntroducerApplicationOfferEntityToContact({ introducerId, applicationId, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/entity_to_contact/`, {
        method: "put",
        body,
    });
}
exports.fetchPutIntroducerApplicationOfferEntityToContact = fetchPutIntroducerApplicationOfferEntityToContact;
exports.GET_INTRODUCER_APPLICATION_OFFER_FUNDING_REQUIREMENTS_KEY = "getIntroducerApplicationOfferFundingRequirements";
/**
 * Gets a list of funding requirements and loan documents required for introducer referred customers
 */
function fetchGetIntroducerApplicationOfferFundingRequirements({ introducerId, applicationId, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/funding_requirements/`, {
        method: "get",
        query,
    });
}
exports.fetchGetIntroducerApplicationOfferFundingRequirements = fetchGetIntroducerApplicationOfferFundingRequirements;
exports.GET_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = "getIntroducerApplicationOfferWithdrawalFeeRate";
/**
 * No description
 */
function fetchGetIntroducerApplicationOfferWithdrawalFeeRate({ introducerId, applicationId, offerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, {
        method: "get",
    });
}
exports.fetchGetIntroducerApplicationOfferWithdrawalFeeRate = fetchGetIntroducerApplicationOfferWithdrawalFeeRate;
exports.PUT_INTRODUCER_APPLICATION_OFFER_WITHDRAWAL_FEE_RATE_KEY = "putIntroducerApplicationOfferWithdrawalFeeRate";
/**
 * No description
 */
function fetchPutIntroducerApplicationOfferWithdrawalFeeRate({ introducerId, applicationId, offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/introducer/${introducerId}/application/${applicationId}/offer/${offerId}/withdrawal_fee_rate/`, {
        method: "put",
        body,
    });
}
exports.fetchPutIntroducerApplicationOfferWithdrawalFeeRate = fetchPutIntroducerApplicationOfferWithdrawalFeeRate;
exports.GET_INTRODUCER_APPLICATION_REJECT_OFFER_REASONS_KEY = "getIntroducerApplicationRejectOfferReasons";
/**
 * No description
 */
function fetchGetIntroducerApplicationRejectOfferReasons({ introducerId, applicationId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${introducerId}/application/${applicationId}/reject_offer_reasons/`, {
        method: "get",
    });
}
exports.fetchGetIntroducerApplicationRejectOfferReasons = fetchGetIntroducerApplicationRejectOfferReasons;
exports.GET_INTRODUCER_APPLICATIONS_KEY = "getIntroducerApplications";
/**
 * No description
 */
function fetchGetIntroducerApplications({ introducerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${introducerId}/applications/`, {
        method: "get",
        query,
    });
}
exports.fetchGetIntroducerApplications = fetchGetIntroducerApplications;
exports.GET_INTRODUCER_CONTEXT_BY_INTRODUCER_ID_KEY = "getIntroducerContextByIntroducerId";
/**
 * No description
 */
function fetchGetIntroducerContextByIntroducerId({ introducerId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/${introducerId}/context/`, {
        method: "get",
    });
}
exports.fetchGetIntroducerContextByIntroducerId = fetchGetIntroducerContextByIntroducerId;
exports.GET_INTRODUCER_CONTEXT_KEY = "getIntroducerContext";
/**
 * No description
 */
function fetchGetIntroducerContext({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/introducer/context/`, {
        method: "get",
    });
}
exports.fetchGetIntroducerContext = fetchGetIntroducerContext;
exports.POST_INTRODUCER_LINK_OPEN_BANKING_EMAIL_KEY = "postIntroducerLinkOpenBankingEmail";
/**
 * Sends an email to an introducer&#x27;s customer to enable linking to open banking
 */
function fetchPostIntroducerLinkOpenBankingEmail({ introducerId, stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/introducer/${introducerId}/link_open_banking_email/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIntroducerLinkOpenBankingEmail = fetchPostIntroducerLinkOpenBankingEmail;
exports.GET_IWOCAPAY_BUYER_PAY_LINK_PACKAGE_KEY = "getIwocapayBuyerPayLinkPackage";
/**
 * No description
 */
function fetchGetIwocapayBuyerPayLinkPackage({ payLinkPackageId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/pay_link_package/${payLinkPackageId}/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayBuyerPayLinkPackage = fetchGetIwocapayBuyerPayLinkPackage;
exports.GET_IWOCAPAY_BUYER_PAY_LINKS_KEY = "getIwocapayBuyerPayLinks";
/**
 * No description
 */
function fetchGetIwocapayBuyerPayLinks({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/${stateKey}/pay_links/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayBuyerPayLinks = fetchGetIwocapayBuyerPayLinks;
exports.POST_IWOCAPAY_BUYER_REFRESH_SPENDING_LIMIT_KEY = "postIwocapayBuyerRefreshSpendingLimit";
/**
 * No description
 */
function fetchPostIwocapayBuyerRefreshSpendingLimit({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/${stateKey}/refresh_spending_limit/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayBuyerRefreshSpendingLimit = fetchPostIwocapayBuyerRefreshSpendingLimit;
exports.GET_IWOCAPAY_BUYER_SPENDING_LIMIT_REQUEST_KEY = "getIwocapayBuyerSpendingLimitRequest";
/**
 * No description
 */
function fetchGetIwocapayBuyerSpendingLimitRequest({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/${stateKey}/spending_limit_request/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayBuyerSpendingLimitRequest = fetchGetIwocapayBuyerSpendingLimitRequest;
exports.POST_IWOCAPAY_BUYER_SPENDING_LIMIT_REQUEST_KEY = "postIwocapayBuyerSpendingLimitRequest";
/**
 * No description
 */
function fetchPostIwocapayBuyerSpendingLimitRequest({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/buyer/${stateKey}/spending_limit_request/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayBuyerSpendingLimitRequest = fetchPostIwocapayBuyerSpendingLimitRequest;
exports.POST_IWOCAPAY_NOTIFICATIONS_KEY = "postIwocapayNotifications";
/**
 * No description
 */
function fetchPostIwocapayNotifications({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/notifications/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayNotifications = fetchPostIwocapayNotifications;
exports.GET_IWOCAPAY_PAY_LINK_PACKAGE_KEY = "getIwocapayPayLinkPackage";
/**
 * No description
 */
function fetchGetIwocapayPayLinkPackage({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/pay_link_package/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayPayLinkPackage = fetchGetIwocapayPayLinkPackage;
exports.POST_IWOCAPAY_PAY_LINK_PACKAGE_KEY = "postIwocapayPayLinkPackage";
/**
 * No description
 */
function fetchPostIwocapayPayLinkPackage({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/pay_link_package/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayPayLinkPackage = fetchPostIwocapayPayLinkPackage;
exports.GET_IWOCAPAY_PAYMENT_CAPTURED_KEY = "getIwocapayPaymentCaptured";
/**
 * No description
 */
function fetchGetIwocapayPaymentCaptured({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/payment/captured/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayPaymentCaptured = fetchGetIwocapayPaymentCaptured;
exports.GET_IWOCAPAY_PAYMENT_LATER_KEY = "getIwocapayPaymentLater";
/**
 * No description
 */
function fetchGetIwocapayPaymentLater({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/payment/later/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayPaymentLater = fetchGetIwocapayPaymentLater;
exports.POST_IWOCAPAY_PAYMENT_LATER_KEY = "postIwocapayPaymentLater";
/**
 * No description
 */
function fetchPostIwocapayPaymentLater({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/payment/later/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayPaymentLater = fetchPostIwocapayPaymentLater;
exports.GET_IWOCAPAY_REFERRAL_KEY = "getIwocapayReferral";
/**
 * No description
 */
function fetchGetIwocapayReferral({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/referral/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayReferral = fetchGetIwocapayReferral;
exports.GET_IWOCAPAY_REFERRALS_KEY = "getIwocapayReferrals";
/**
 * No description
 */
function fetchGetIwocapayReferrals({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/referrals/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayReferrals = fetchGetIwocapayReferrals;
exports.GET_IWOCAPAY_REFERRER_KEY = "getIwocapayReferrer";
/**
 * No description
 */
function fetchGetIwocapayReferrer({ referralCode, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/referrer/${referralCode}/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayReferrer = fetchGetIwocapayReferrer;
exports.DELETE_IWOCAPAY_SELLER_ACCESS_USER_KEY = "deleteIwocapaySellerAccessUser";
/**
 * No description
 */
function fetchDeleteIwocapaySellerAccessUser({ stateKey, accessUserUuid, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${stateKey}/access_user/${accessUserUuid}/`, {
        method: "delete",
        body,
    });
}
exports.fetchDeleteIwocapaySellerAccessUser = fetchDeleteIwocapaySellerAccessUser;
exports.PUT_IWOCAPAY_SELLER_ACCESS_USER_KEY = "putIwocapaySellerAccessUser";
/**
 * No description
 */
function fetchPutIwocapaySellerAccessUser({ stateKey, accessUserUuid, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${stateKey}/access_user/${accessUserUuid}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutIwocapaySellerAccessUser = fetchPutIwocapaySellerAccessUser;
exports.GET_IWOCAPAY_SELLER_ACCESS_USERS_KEY = "getIwocapaySellerAccessUsers";
/**
 * No description
 */
function fetchGetIwocapaySellerAccessUsers({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${stateKey}/access_users/`, {
        method: "get",
    });
}
exports.fetchGetIwocapaySellerAccessUsers = fetchGetIwocapaySellerAccessUsers;
exports.POST_IWOCAPAY_SELLER_ACCESS_USERS_KEY = "postIwocapaySellerAccessUsers";
/**
 * No description
 */
function fetchPostIwocapaySellerAccessUsers({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${stateKey}/access_users/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapaySellerAccessUsers = fetchPostIwocapaySellerAccessUsers;
exports.GET_IWOCAPAY_SELLER_BRANDING_KEY = "getIwocapaySellerBranding";
/**
 * No description
 */
function fetchGetIwocapaySellerBranding({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${stateKey}/branding/`, {
        method: "get",
    });
}
exports.fetchGetIwocapaySellerBranding = fetchGetIwocapaySellerBranding;
exports.GET_IWOCAPAY_SELLER_CONNECTION_KEY = "getIwocapaySellerConnection";
/**
 * No description
 */
function fetchGetIwocapaySellerConnection({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${stateKey}/connection/`, {
        method: "get",
    });
}
exports.fetchGetIwocapaySellerConnection = fetchGetIwocapaySellerConnection;
exports.GET_IWOCAPAY_SELLER_ECOMMERCE_CREDENTIALS_KEY = "getIwocapaySellerEcommerceCredentials";
/**
 * No description
 */
function fetchGetIwocapaySellerEcommerceCredentials({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${stateKey}/ecommerce_credentials/`, {
        method: "get",
    });
}
exports.fetchGetIwocapaySellerEcommerceCredentials = fetchGetIwocapaySellerEcommerceCredentials;
exports.POST_IWOCAPAY_SELLER_ECOMMERCE_CREDENTIALS_KEY = "postIwocapaySellerEcommerceCredentials";
/**
 * No description
 */
function fetchPostIwocapaySellerEcommerceCredentials({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${stateKey}/ecommerce_credentials/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapaySellerEcommerceCredentials = fetchPostIwocapaySellerEcommerceCredentials;
exports.PUT_IWOCAPAY_SELLER_PAYMENT_CAPTURED_CANCEL_KEY = "putIwocapaySellerPaymentCapturedCancel";
/**
 * No description
 */
function fetchPutIwocapaySellerPaymentCapturedCancel({ stateKey, payLinkId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${stateKey}/payment/captured/${payLinkId}/cancel/`, {
        method: "put",
        body,
    });
}
exports.fetchPutIwocapaySellerPaymentCapturedCancel = fetchPutIwocapaySellerPaymentCapturedCancel;
exports.PUT_IWOCAPAY_SELLER_PAYMENT_CAPTURED_FUND_KEY = "putIwocapaySellerPaymentCapturedFund";
/**
 * No description
 */
function fetchPutIwocapaySellerPaymentCapturedFund({ stateKey, payLinkId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${stateKey}/payment/captured/${payLinkId}/fund/`, {
        method: "put",
        body,
    });
}
exports.fetchPutIwocapaySellerPaymentCapturedFund = fetchPutIwocapaySellerPaymentCapturedFund;
exports.POST_IWOCAPAY_SELLER_RESEND_INVITE_KEY = "postIwocapaySellerResendInvite";
/**
 * No description
 */
function fetchPostIwocapaySellerResendInvite({ stateKey, accessUserUuid, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller/${stateKey}/resend_invite/${accessUserUuid}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapaySellerResendInvite = fetchPostIwocapaySellerResendInvite;
exports.GET_IWOCAPAY_SELLER_SPENDING_LIMIT_REQUEST_KEY = "getIwocapaySellerSpendingLimitRequest";
/**
 * No description
 */
function fetchGetIwocapaySellerSpendingLimitRequest({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller/${stateKey}/spending_limit_request/`, {
        method: "get",
    });
}
exports.fetchGetIwocapaySellerSpendingLimitRequest = fetchGetIwocapaySellerSpendingLimitRequest;
exports.GET_IWOCAPAY_SELLER_ONBOARDING_ANSWERS_KEY = "getIwocapaySellerOnboardingAnswers";
/**
 * No description
 */
function fetchGetIwocapaySellerOnboardingAnswers({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/seller_onboarding_answers/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetIwocapaySellerOnboardingAnswers = fetchGetIwocapaySellerOnboardingAnswers;
exports.POST_IWOCAPAY_SELLER_ONBOARDING_ANSWERS_KEY = "postIwocapaySellerOnboardingAnswers";
/**
 * No description
 */
function fetchPostIwocapaySellerOnboardingAnswers({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/seller_onboarding_answers/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapaySellerOnboardingAnswers = fetchPostIwocapaySellerOnboardingAnswers;
exports.POST_IWOCAPAY_SHOPIFY_GDPR_REDACT_CUSTOMER_KEY = "postIwocapayShopifyGdprRedactCustomer";
/**
 * No description
 */
function fetchPostIwocapayShopifyGdprRedactCustomer({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/shopify/gdpr/redact/customer/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayShopifyGdprRedactCustomer = fetchPostIwocapayShopifyGdprRedactCustomer;
exports.POST_IWOCAPAY_SHOPIFY_GDPR_REDACT_SHOP_KEY = "postIwocapayShopifyGdprRedactShop";
/**
 * No description
 */
function fetchPostIwocapayShopifyGdprRedactShop({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/shopify/gdpr/redact/shop/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayShopifyGdprRedactShop = fetchPostIwocapayShopifyGdprRedactShop;
exports.POST_IWOCAPAY_SHOPIFY_GDPR_RETRIEVE_CUSTOMER_KEY = "postIwocapayShopifyGdprRetrieveCustomer";
/**
 * No description
 */
function fetchPostIwocapayShopifyGdprRetrieveCustomer({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/shopify/gdpr/retrieve/customer/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayShopifyGdprRetrieveCustomer = fetchPostIwocapayShopifyGdprRetrieveCustomer;
exports.GET_IWOCAPAY_SHOPIFY_INSTALL_KEY = "getIwocapayShopifyInstall";
/**
 * HTTP 302 redirect to Shopify grant screen.
 */
function fetchGetIwocapayShopifyInstall({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/shopify/install/`, {
        method: "get",
        query,
    });
}
exports.fetchGetIwocapayShopifyInstall = fetchGetIwocapayShopifyInstall;
exports.POST_IWOCAPAY_SHOPIFY_PAYMENT_KEY = "postIwocapayShopifyPayment";
/**
 * No description
 */
function fetchPostIwocapayShopifyPayment({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/shopify/payment/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayShopifyPayment = fetchPostIwocapayShopifyPayment;
exports.POST_IWOCAPAY_SHOPIFY_PAYMENT_REFUND_KEY = "postIwocapayShopifyPaymentRefund";
/**
 * No description
 */
function fetchPostIwocapayShopifyPaymentRefund({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/shopify/payment/refund/`, {
        method: "post",
        body,
    });
}
exports.fetchPostIwocapayShopifyPaymentRefund = fetchPostIwocapayShopifyPaymentRefund;
exports.GET_IWOCAPAY_SHOPIFY_POST_GRANT_KEY = "getIwocapayShopifyPostGrant";
/**
 * Requests/stores OAuth access token for shop, then HTTP 302 redirect to app UI.
 */
function fetchGetIwocapayShopifyPostGrant({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/iwocapay/shopify/post_grant/`, {
        method: "get",
        query,
    });
}
exports.fetchGetIwocapayShopifyPostGrant = fetchGetIwocapayShopifyPostGrant;
exports.GET_IWOCAPAY_SHOPIFY_SELLER_SHOP_KEY = "getIwocapayShopifySellerShop";
/**
 * No description
 */
function fetchGetIwocapayShopifySellerShop({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/iwocapay/shopify/seller/${stateKey}/shop/`, {
        method: "get",
    });
}
exports.fetchGetIwocapayShopifySellerShop = fetchGetIwocapayShopifySellerShop;
exports.GET_LOAN_DOCUMENTS_KEY = "getLoanDocuments";
/**
 * No description
 */
function fetchGetLoanDocuments({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetLoanDocuments = fetchGetLoanDocuments;
exports.GET_LOAN_DOCUMENTS_REQUIRED_BUSINESS_LOAN_KEY = "getLoanDocumentsRequiredBusinessLoan";
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredBusinessLoan({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/required/business_loan/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsRequiredBusinessLoan = fetchGetLoanDocumentsRequiredBusinessLoan;
exports.GET_LOAN_DOCUMENTS_REQUIRED_CBILS_KEY = "getLoanDocumentsRequiredCbils";
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredCbils({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/required/cbils/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsRequiredCbils = fetchGetLoanDocumentsRequiredCbils;
exports.GET_LOAN_DOCUMENTS_REQUIRED_CREDIT_FACILITY_KEY = "getLoanDocumentsRequiredCreditFacility";
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredCreditFacility({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/required/credit_facility/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsRequiredCreditFacility = fetchGetLoanDocumentsRequiredCreditFacility;
exports.GET_LOAN_DOCUMENTS_REQUIRED_FLEXI_24_KEY = "getLoanDocumentsRequiredFlexi24";
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredFlexi24({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/required/flexi24/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsRequiredFlexi24 = fetchGetLoanDocumentsRequiredFlexi24;
exports.GET_LOAN_DOCUMENTS_REQUIRED_IWOCAPAY_KEY = "getLoanDocumentsRequiredIwocapay";
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredIwocapay({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/required/iwocapay/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsRequiredIwocapay = fetchGetLoanDocumentsRequiredIwocapay;
exports.GET_LOAN_DOCUMENTS_REQUIRED_MERCHANT_CASH_ADVANCE_KEY = "getLoanDocumentsRequiredMerchantCashAdvance";
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredMerchantCashAdvance({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/required/merchant_cash_advance/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsRequiredMerchantCashAdvance = fetchGetLoanDocumentsRequiredMerchantCashAdvance;
exports.GET_LOAN_DOCUMENTS_REQUIRED_RECOVERY_LOAN_KEY = "getLoanDocumentsRequiredRecoveryLoan";
/**
 * Returns details of documents that must be signed before drawdown

To ensure the documents have the correct information, it may be necessary
to specify additional url parameters depending on the product.
If not all url paramaters are provided, the system will
make a guess based on any offer configuration and other features
of the offer.

Parameters that are not available in the offer configuration
endpoint are unlikely to substantially affect funding parameters,
but it is still advisable to provide as complete information
as possible.

 */
function fetchGetLoanDocumentsRequiredRecoveryLoan({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/required/recovery_loan/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsRequiredRecoveryLoan = fetchGetLoanDocumentsRequiredRecoveryLoan;
exports.POST_LOAN_DOCUMENTS_SIGNED_KEY = "postLoanDocumentsSigned";
/**
 * No description
 */
function fetchPostLoanDocumentsSigned({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/loan_documents/${stateKey}/signed/`, {
        method: "post",
        body,
    });
}
exports.fetchPostLoanDocumentsSigned = fetchPostLoanDocumentsSigned;
exports.GET_LOAN_DOCUMENTS_SIGNED_KEY = "getLoanDocumentsSigned";
/**
 * No description
 */
function fetchGetLoanDocumentsSigned({ stateKey, documentId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/loan_documents/${stateKey}/signed/${documentId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsSigned = fetchGetLoanDocumentsSigned;
exports.GET_LOAN_DOCUMENTS_UNSIGNED_KEY = "getLoanDocumentsUnsigned";
/**
 * No description
 */
function fetchGetLoanDocumentsUnsigned({ stateKey, documentId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/loan_documents/${stateKey}/unsigned/${documentId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetLoanDocumentsUnsigned = fetchGetLoanDocumentsUnsigned;
exports.GET_LOGIN_LINK_KEY = "getLoginLink";
/**
 * No description
 */
function fetchGetLoginLink({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/login_link/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetLoginLink = fetchGetLoginLink;
exports.POST_LOGOUT_KEY = "postLogout";
/**
 * No description
 */
function fetchPostLogout({ body }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/logout/`, {
        method: "post",
        body,
    });
}
exports.fetchPostLogout = fetchPostLogout;
exports.GET_MCA_ESTIMATED_SCHEDULE_KEY = "getMcaEstimatedSchedule";
/**
 * Returning the merchant cash advance estimated schedule for a customer. Allows to estimate a schedule providing different amounts and sweep fractions.
 */
function fetchGetMcaEstimatedSchedule({ stateKey, offerId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/mca_estimated_schedule/${stateKey}/${offerId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetMcaEstimatedSchedule = fetchGetMcaEstimatedSchedule;
exports.POST_OFFERS_SELECT_KEY = "postOffersSelect";
/**
 * Select an offer that the customer would like to proceed with.
 */
function fetchPostOffersSelect({ offerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/offers/${offerId}/select/`, {
        method: "post",
        body,
    });
}
exports.fetchPostOffersSelect = fetchPostOffersSelect;
exports.GET_ONFIDO_CHECK_KEY = "getOnfidoCheck";
/**
 * No description
 */
function fetchGetOnfidoCheck({ stateKey, personUid, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/onfido/check/${stateKey}/${personUid}/`, {
        method: "get",
    });
}
exports.fetchGetOnfidoCheck = fetchGetOnfidoCheck;
exports.POST_ONFIDO_CHECK_KEY = "postOnfidoCheck";
/**
 * No description
 */
function fetchPostOnfidoCheck({ stateKey, personUid, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/onfido/check/${stateKey}/${personUid}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostOnfidoCheck = fetchPostOnfidoCheck;
exports.POST_ONFIDO_CHECKS_KEY = "postOnfidoChecks";
/**
 * No description
 */
function fetchPostOnfidoChecks({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/onfido/checks/`, {
        method: "post",
        body,
    });
}
exports.fetchPostOnfidoChecks = fetchPostOnfidoChecks;
exports.POST_ONFIDO_START_KEY = "postOnfidoStart";
/**
 * No description
 */
function fetchPostOnfidoStart({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/onfido/start/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostOnfidoStart = fetchPostOnfidoStart;
exports.POST_ONFIDO_TOKEN_KEY = "postOnfidoToken";
/**
 * No description
 */
function fetchPostOnfidoToken({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/onfido/token/`, {
        method: "post",
        body,
    });
}
exports.fetchPostOnfidoToken = fetchPostOnfidoToken;
exports.GET_ONLINE_ACCOUNT_KEY = "getOnlineAccount";
/**
 * No description
 */
function fetchGetOnlineAccount({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/online_account/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetOnlineAccount = fetchGetOnlineAccount;
exports.DELETE_ONLINE_ACCOUNT_KEY = "deleteOnlineAccount";
/**
 * No description
 */
function fetchDeleteOnlineAccount({ stateKey, onlineAccountId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/online_account/${stateKey}/${onlineAccountId}/`, {
        method: "delete",
        body,
    });
}
exports.fetchDeleteOnlineAccount = fetchDeleteOnlineAccount;
exports.POST_PAGE_VIEW_KEY = "postPageView";
/**
 * Create a page view log entry
 */
function fetchPostPageView({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/page_view/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPageView = fetchPostPageView;
exports.GET_PARTNER_BROKERS_KEY = "getPartnerBrokers";
/**
 * Returns a list of all brokers, including default one, associated with a partner
 */
function fetchGetPartnerBrokers({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/partner_brokers/`, {
        method: "get",
    });
}
exports.fetchGetPartnerBrokers = fetchGetPartnerBrokers;
exports.POST_PARTNER_DEVELOPER_KEY = "postPartnerDeveloper";
/**
 * Create a partner developer
 */
function fetchPostPartnerDeveloper({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/partner_developer/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPartnerDeveloper = fetchPostPartnerDeveloper;
exports.POST_PASSWORD_LOGIN_KEY = "postPasswordLogin";
/**
 * No description
 */
function fetchPostPasswordLogin({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/password/login/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPasswordLogin = fetchPostPasswordLogin;
exports.POST_PASSWORD_RESET_KEY = "postPasswordReset";
/**
 * No description
 */
function fetchPostPasswordReset({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/password/reset/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPasswordReset = fetchPostPasswordReset;
exports.POST_PASSWORD_RESET_SET_PASSWORD_KEY = "postPasswordResetSetPassword";
/**
 * No description
 */
function fetchPostPasswordResetSetPassword({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/password/reset/set-password/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPasswordResetSetPassword = fetchPostPasswordResetSetPassword;
exports.POST_PASSWORD_RESET_VERIFY_KEY = "postPasswordResetVerify";
/**
 * No description
 */
function fetchPostPasswordResetVerify({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/password/reset/verify/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPasswordResetVerify = fetchPostPasswordResetVerify;
exports.POST_PASSWORDLESS_EMAIL_KEY = "postPasswordlessEmail";
/**
 * No description
 */
function fetchPostPasswordlessEmail({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/passwordless/email/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPasswordlessEmail = fetchPostPasswordlessEmail;
exports.POST_PASSWORDLESS_EMAIL_LOGIN_KEY = "postPasswordlessEmailLogin";
/**
 * No description
 */
function fetchPostPasswordlessEmailLogin({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/passwordless/email/login/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPasswordlessEmailLogin = fetchPostPasswordlessEmailLogin;
exports.GET_PAY_LINK_GO_KEY = "getPayLinkGo";
/**
 * Redirect to a pay link page corresponding to a external link.
 */
function fetchGetPayLinkGo({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/pay_link/go/`, {
        method: "get",
        query,
    });
}
exports.fetchGetPayLinkGo = fetchGetPayLinkGo;
exports.GET_PAY_LINK_KEY = "getPayLink";
/**
 * No description
 */
function fetchGetPayLink({ payLinkId }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/pay_link/${payLinkId}/`, {
        method: "get",
    });
}
exports.fetchGetPayLink = fetchGetPayLink;
exports.POST_PAY_LINK_APPLICATION_KEY = "postPayLinkApplication";
/**
 * TBD
 */
function fetchPostPayLinkApplication({ payLinkId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/pay_link/${payLinkId}/application/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPayLinkApplication = fetchPostPayLinkApplication;
exports.GET_PAYMENT_METHOD_KEY = "getPaymentMethod";
/**
 * Retrieve the payment methods linked to the customer.
 */
function fetchGetPaymentMethod({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/payment_method/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetPaymentMethod = fetchGetPaymentMethod;
exports.POST_PAYMENT_METHOD_KEY = "postPaymentMethod";
/**
 * Sending a POST request with a valid body will result in creating a chargeable payment method for the specified customer.
 */
function fetchPostPaymentMethod({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/payment_method/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostPaymentMethod = fetchPostPaymentMethod;
exports.DELETE_PAYMENT_METHOD_KEY = "deletePaymentMethod";
/**
 * No description
 */
function fetchDeletePaymentMethod({ stateKey, paymentMethodId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/payment_method/${stateKey}/${paymentMethodId}/`, {
        method: "delete",
        body,
    });
}
exports.fetchDeletePaymentMethod = fetchDeletePaymentMethod;
exports.PUT_PAYMENT_METHOD_KEY = "putPaymentMethod";
/**
 * No description
 */
function fetchPutPaymentMethod({ stateKey, paymentMethodId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/payment_method/${stateKey}/${paymentMethodId}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutPaymentMethod = fetchPutPaymentMethod;
exports.GET_POSTCODE_LOOKUP_KEY = "getPostcodeLookup";
/**
 * No description
 */
function fetchGetPostcodeLookup({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/postcode_lookup/`, {
        method: "get",
        query,
    });
}
exports.fetchGetPostcodeLookup = fetchGetPostcodeLookup;
exports.GET_PRODUCT_OFFERS_BY_RESTRICTED_EXTERNAL_DATA_SYNCS_AUTHORISATION_KEY = "getProductOffersByRestrictedExternalDataSyncsAuthorisation";
/**
 * No description
 */
function fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation({ stateKey, restrictedExternalDataSyncsAuthorisation, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/product_offers/${stateKey}/${restrictedExternalDataSyncsAuthorisation}/`, {
        method: "get",
    });
}
exports.fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation = fetchGetProductOffersByRestrictedExternalDataSyncsAuthorisation;
exports.GET_PRODUCT_OFFERS_KEY = "getProductOffers";
/**
 * No description
 */
function fetchGetProductOffers({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/product_offers/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetProductOffers = fetchGetProductOffers;
exports.GET_PROFILE_KEY = "getProfile";
/**
 * Read access to user info
 */
function fetchGetProfile({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/profile/`, {
        method: "get",
    });
}
exports.fetchGetProfile = fetchGetProfile;
exports.GET_QUICKBOOKS_AUTHORIZATION_CALLBACK_KEY = "getQuickbooksAuthorizationCallback";
/**
 * Saves quickbooks connection and redirects to the frontend integrations page.
 */
function fetchGetQuickbooksAuthorizationCallback({}) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/quickbooks/authorization_callback/`, {
        method: "get",
    });
}
exports.fetchGetQuickbooksAuthorizationCallback = fetchGetQuickbooksAuthorizationCallback;
exports.GET_QUICKBOOKS_AUTHORIZATION_REDIRECT_KEY = "getQuickbooksAuthorizationRedirect";
/**
 * Redirects to quickbooks auth page.
 */
function fetchGetQuickbooksAuthorizationRedirect({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/quickbooks/authorization_redirect/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetQuickbooksAuthorizationRedirect = fetchGetQuickbooksAuthorizationRedirect;
exports.POST_QUICKBOOKS_DISCONNECT_KEY = "postQuickbooksDisconnect";
/**
 * No description
 */
function fetchPostQuickbooksDisconnect({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/quickbooks/disconnect/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostQuickbooksDisconnect = fetchPostQuickbooksDisconnect;
exports.POST_QUICKBOOKS_WEBHOOK_KEY = "postQuickbooksWebhook";
/**
 * No description
 */
function fetchPostQuickbooksWebhook({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/quickbooks/webhook/`, {
        method: "post",
        body,
    });
}
exports.fetchPostQuickbooksWebhook = fetchPostQuickbooksWebhook;
exports.POST_REPAYMENT_PAYMENT_INTENT_KEY = "postRepaymentPaymentIntent";
/**
 * Create an intent to pay.
 */
function fetchPostRepaymentPaymentIntent({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/repayment/${stateKey}/payment_intent/`, {
        method: "post",
        body,
    });
}
exports.fetchPostRepaymentPaymentIntent = fetchPostRepaymentPaymentIntent;
exports.GET_REPAYMENT_PAYMENT_METHOD_KEY = "getRepaymentPaymentMethod";
/**
 * Get all repayment methods for the given state key
 */
function fetchGetRepaymentPaymentMethod({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/repayment/${stateKey}/payment_method/`, {
        method: "get",
    });
}
exports.fetchGetRepaymentPaymentMethod = fetchGetRepaymentPaymentMethod;
exports.POST_REPAYMENT_PAYMENT_METHOD_KEY = "postRepaymentPaymentMethod";
/**
 * Create an intent to add a card or direct debit mandate.
 */
function fetchPostRepaymentPaymentMethod({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/repayment/${stateKey}/payment_method/`, {
        method: "post",
        body,
    });
}
exports.fetchPostRepaymentPaymentMethod = fetchPostRepaymentPaymentMethod;
exports.POST_REPAYMENT_REGISTER_REPAYMENT_METHOD_KEY = "postRepaymentRegisterRepaymentMethod";
/**
 * No description
 */
function fetchPostRepaymentRegisterRepaymentMethod({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/repayment/${stateKey}/register_repayment_method/`, {
        method: "post",
        body,
    });
}
exports.fetchPostRepaymentRegisterRepaymentMethod = fetchPostRepaymentRegisterRepaymentMethod;
exports.GET_SELECT_PAYMENT_PROCESSOR_KEY = "getSelectPaymentProcessor";
/**
 * No description
 */
function fetchGetSelectPaymentProcessor({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/select_payment_processor/`, {
        method: "get",
    });
}
exports.fetchGetSelectPaymentProcessor = fetchGetSelectPaymentProcessor;
exports.GET_SELLER_HANDLE_KEY = "getSellerHandle";
/**
 * No description
 */
function fetchGetSellerHandle({ sellerHandle, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/handle/${sellerHandle}/`, {
        method: "get",
    });
}
exports.fetchGetSellerHandle = fetchGetSellerHandle;
exports.GET_SELLER_HANDLE_AVAILABILITY_KEY = "getSellerHandleAvailability";
/**
 * No description
 */
function fetchGetSellerHandleAvailability({ sellerHandle, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/handle/${sellerHandle}/availability/`, {
        method: "get",
    });
}
exports.fetchGetSellerHandleAvailability = fetchGetSellerHandleAvailability;
exports.GET_SELLER_KEY = "getSeller";
/**
 * No description
 */
function fetchGetSeller({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetSeller = fetchGetSeller;
exports.POST_SELLER_KEY = "postSeller";
/**
 * No description
 */
function fetchPostSeller({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSeller = fetchPostSeller;
exports.GET_SELLER_ENABLED_PRODUCTS_KEY = "getSellerEnabledProducts";
/**
 * No description
 */
function fetchGetSellerEnabledProducts({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/${stateKey}/enabled_products/`, {
        method: "get",
    });
}
exports.fetchGetSellerEnabledProducts = fetchGetSellerEnabledProducts;
exports.PUT_SELLER_ENABLED_PRODUCTS_KEY = "putSellerEnabledProducts";
/**
 * No description
 */
function fetchPutSellerEnabledProducts({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/${stateKey}/enabled_products/`, {
        method: "put",
        body,
    });
}
exports.fetchPutSellerEnabledProducts = fetchPutSellerEnabledProducts;
exports.POST_SELLER_HANDLE_KEY = "postSellerHandle";
/**
 * No description
 */
function fetchPostSellerHandle({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/${stateKey}/handle/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSellerHandle = fetchPostSellerHandle;
exports.GET_SELLER_INTEGRATIONS_REGISTER_INTEREST_KEY = "getSellerIntegrationsRegisterInterest";
/**
 * No description
 */
function fetchGetSellerIntegrationsRegisterInterest({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/${stateKey}/integrations/register_interest/`, {
        method: "get",
    });
}
exports.fetchGetSellerIntegrationsRegisterInterest = fetchGetSellerIntegrationsRegisterInterest;
exports.POST_SELLER_INTEGRATIONS_REGISTER_INTEREST_KEY = "postSellerIntegrationsRegisterInterest";
/**
 * No description
 */
function fetchPostSellerIntegrationsRegisterInterest({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller/${stateKey}/integrations/register_interest/`, {
        method: "post",
        body,
    });
}
exports.fetchPostSellerIntegrationsRegisterInterest = fetchPostSellerIntegrationsRegisterInterest;
exports.GET_SELLER_AGREEMENT_DOCUMENT_KEY = "getSellerAgreementDocument";
/**
 * No description
 */
function fetchGetSellerAgreementDocument({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller_agreement_document/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetSellerAgreementDocument = fetchGetSellerAgreementDocument;
exports.GET_SELLER_AGREEMENT_DOCUMENT_DOWNLOAD_KEY = "getSellerAgreementDocumentDownload";
/**
 * No description
 */
function fetchGetSellerAgreementDocumentDownload({ stateKey, documentId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/seller_agreement_document/${stateKey}/download/${documentId}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetSellerAgreementDocumentDownload = fetchGetSellerAgreementDocumentDownload;
exports.PUT_SELLER_AGREEMENT_DOCUMENT_SIGN_KEY = "putSellerAgreementDocumentSign";
/**
 * No description
 */
function fetchPutSellerAgreementDocumentSign({ stateKey, documentId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/seller_agreement_document/${stateKey}/sign/${documentId}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutSellerAgreementDocumentSign = fetchPutSellerAgreementDocumentSign;
exports.GET_SELLER_ONBOARDING_REQUIREMENTS_KEY = "getSellerOnboardingRequirements";
/**
 * No description
 */
function fetchGetSellerOnboardingRequirements({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/seller_onboarding_requirements/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetSellerOnboardingRequirements = fetchGetSellerOnboardingRequirements;
exports.GET_SIGNUP_BRANDING_KEY = "getSignupBranding";
/**
 * No description
 */
function fetchGetSignupBranding({ affiliateTag, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/signup_branding/${affiliateTag}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetSignupBranding = fetchGetSignupBranding;
exports.GET_SINGLE_IMMEDIATE_PAYMENT_KEY = "getSingleImmediatePayment";
/**
 * No description
 */
function fetchGetSingleImmediatePayment({ paymentId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/single_immediate_payment/${paymentId}/`, {
        method: "get",
    });
}
exports.fetchGetSingleImmediatePayment = fetchGetSingleImmediatePayment;
exports.GET_SPLIT_TEST_KEY = "getSplitTest";
/**
 * No description
 */
function fetchGetSplitTest({ stateKey, experimentName, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/split_test/${stateKey}/${experimentName}/`, {
        method: "get",
    });
}
exports.fetchGetSplitTest = fetchGetSplitTest;
exports.POST_STATE_KEY = "postState";
/**
 * The POST request should be used to create an iwoca account for the customer. It&#x27;s always the first endpoint and method you should call when submitting a new customer. We&#x27;ll return a state_key used to identify the customer in all future requests. Almost all fields in the State are optional since you can submit a partial application initially, then add or update data over time (through the PUT method). Your iwoca contact will be able to give you details on which fields are recommended to help us make a lending decision.
 */
function fetchPostState({ headers, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/state/`, {
        method: "post",
        overrideHeaders: headers,
        body,
    });
}
exports.fetchPostState = fetchPostState;
exports.GET_STATE_BY_STATE_KEY_KEY = "getStateByStateKey";
/**
 * No description
 */
function fetchGetStateByStateKey({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/state/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetStateByStateKey = fetchGetStateByStateKey;
exports.GET_STATE_KEY = "getState";
/**
 * No description
 */
function fetchGetState({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/state/`, {
        method: "get",
    });
}
exports.fetchGetState = fetchGetState;
exports.PUT_STATE_KEY = "putState";
/**
 * The PUT request should be used to add or update data for a customer. Note that the entire State should be submitted each time you use this endpoint, even if you are just updating a few fields.
 */
function fetchPutState({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/state/${stateKey}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutState = fetchPutState;
exports.GET_STATEMENTS_KEY = "getStatements";
/**
 * No description
 */
function fetchGetStatements({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/statements/${stateKey}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetStatements = fetchGetStatements;
exports.POST_THREATMETRIX_EVENT_KEY = "postThreatmetrixEvent";
/**
 * Create a ThreatMetrix event
 */
function fetchPostThreatmetrixEvent({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/threatmetrix/${stateKey}/event/`, {
        method: "post",
        body,
    });
}
exports.fetchPostThreatmetrixEvent = fetchPostThreatmetrixEvent;
exports.PUT_THREATMETRIX_EVENT_KEY = "putThreatmetrixEvent";
/**
 * Update a ThreatMetrix event.
 */
function fetchPutThreatmetrixEvent({ stateKey, tmSessionId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/threatmetrix/${stateKey}/event/${tmSessionId}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutThreatmetrixEvent = fetchPutThreatmetrixEvent;
exports.POST_TRUELAYER_AUTHORIZATION_URL_KEY = "postTruelayerAuthorizationUrl";
/**
 * Get truelayer authorization url(open banking) for a customer
 */
function fetchPostTruelayerAuthorizationUrl({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/truelayer/authorization_url/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostTruelayerAuthorizationUrl = fetchPostTruelayerAuthorizationUrl;
exports.POST_TRUELAYER_BANK_AUTHENTICATION_URL_KEY = "postTruelayerBankAuthenticationUrl";
/**
 * Get truelayer direct bank auth url(open banking) for a customer
 */
function fetchPostTruelayerBankAuthenticationUrl({ stateKey, providerId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/truelayer/bank_authentication_url/${stateKey}/${providerId}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostTruelayerBankAuthenticationUrl = fetchPostTruelayerBankAuthenticationUrl;
exports.GET_TRUELAYER_PAYMENT_KEY = "getTruelayerPayment";
/**
 * Given that the state key provided matches the user associated with the Truelayer Payment, returns details from finance.payment.truelayer.models.TruelayerPayment.
 */
function fetchGetTruelayerPayment({ stateKey, paymentId, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/truelayer_payment/${stateKey}/${paymentId}/`, {
        method: "get",
    });
}
exports.fetchGetTruelayerPayment = fetchGetTruelayerPayment;
exports.POST_TWO_FACTOR_AUTHENTICATE_KEY = "postTwoFactorAuthenticate";
/**
 * No description
 */
function fetchPostTwoFactorAuthenticate({ authenticationToken, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/two_factor/${authenticationToken}/authenticate/`, {
        method: "post",
        body,
    });
}
exports.fetchPostTwoFactorAuthenticate = fetchPostTwoFactorAuthenticate;
exports.GET_TWO_FACTOR_SETUP_KEY = "getTwoFactorSetup";
/**
 * No description
 */
function fetchGetTwoFactorSetup({ authenticationToken, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/two_factor/${authenticationToken}/setup/`, {
        method: "get",
    });
}
exports.fetchGetTwoFactorSetup = fetchGetTwoFactorSetup;
exports.POST_TWO_FACTOR_SETUP_KEY = "postTwoFactorSetup";
/**
 * No description
 */
function fetchPostTwoFactorSetup({ authenticationToken, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/two_factor/${authenticationToken}/setup/`, {
        method: "post",
        body,
    });
}
exports.fetchPostTwoFactorSetup = fetchPostTwoFactorSetup;
exports.GET_XERO_ACCOUNTS_KEY = "getXeroAccounts";
/**
 * Return a list of Xero accounts.
 */
function fetchGetXeroAccounts({ reason, stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/xero/accounts/${reason}/${stateKey}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetXeroAccounts = fetchGetXeroAccounts;
exports.GET_XERO_CALLBACK_KEY = "getXeroCallback";
/**
 * Callback url after successful Xero authorisation.
 */
function fetchGetXeroCallback({ reason, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/callback/${reason}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetXeroCallback = fetchGetXeroCallback;
exports.POST_XERO_CONNECT_KEY = "postXeroConnect";
/**
 * Exchange the authorisation code for an access token.
 */
function fetchPostXeroConnect({ reason, stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/connect/${reason}/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostXeroConnect = fetchPostXeroConnect;
exports.DELETE_XERO_CONNECTIONS_KEY = "deleteXeroConnections";
/**
 * Remove an individual tenant connection.
 */
function fetchDeleteXeroConnections({ reason, stateKey, query, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/connections/${reason}/${stateKey}/`, {
        method: "delete",
        query,
        body,
    });
}
exports.fetchDeleteXeroConnections = fetchDeleteXeroConnections;
exports.GET_XERO_CONNECTIONS_KEY = "getXeroConnections";
/**
 * Returns a list of tenants and the related organisation iwoca is authorized to access.
 */
function fetchGetXeroConnections({ reason, stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/xero/connections/${reason}/${stateKey}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetXeroConnections = fetchGetXeroConnections;
exports.GET_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = "getXeroIwocapaySellerAccount";
/**
 * No description
 */
function fetchGetXeroIwocapaySellerAccount({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/xero/iwocapay_seller/account/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetXeroIwocapaySellerAccount = fetchGetXeroIwocapaySellerAccount;
exports.POST_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = "postXeroIwocapaySellerAccount";
/**
 * No description
 */
function fetchPostXeroIwocapaySellerAccount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/iwocapay_seller/account/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostXeroIwocapaySellerAccount = fetchPostXeroIwocapaySellerAccount;
exports.PUT_XERO_IWOCAPAY_SELLER_ACCOUNT_KEY = "putXeroIwocapaySellerAccount";
/**
 * No description
 */
function fetchPutXeroIwocapaySellerAccount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/iwocapay_seller/account/${stateKey}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutXeroIwocapaySellerAccount = fetchPutXeroIwocapaySellerAccount;
exports.GET_XERO_IWOCAPAY_SELLER_BRANDING_THEMES_KEY = "getXeroIwocapaySellerBrandingThemes";
/**
 * Return a list of Xero branding themes.
 */
function fetchGetXeroIwocapaySellerBrandingThemes({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/xero/iwocapay_seller/branding_themes/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetXeroIwocapaySellerBrandingThemes = fetchGetXeroIwocapaySellerBrandingThemes;
exports.POST_XERO_IWOCAPAY_SELLER_BRANDING_THEMES_PAYMENT_SERVICES_KEY = "postXeroIwocapaySellerBrandingThemesPaymentServices";
/**
 * Add iwocaPay as a new payment service to list of branding themes.
 */
function fetchPostXeroIwocapaySellerBrandingThemesPaymentServices({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/iwocapay_seller/branding_themes/${stateKey}/payment_services/`, {
        method: "post",
        body,
    });
}
exports.fetchPostXeroIwocapaySellerBrandingThemesPaymentServices = fetchPostXeroIwocapaySellerBrandingThemesPaymentServices;
exports.GET_XERO_LOGIN_KEY = "getXeroLogin";
/**
 * HTTP 302 redirect to Xero for authorization.
 */
function fetchGetXeroLogin({ reason, stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/login/${reason}/${stateKey}/`, {
        method: "get",
        query,
    });
}
exports.fetchGetXeroLogin = fetchGetXeroLogin;
exports.POST_XERO_LOGIN_KEY = "postXeroLogin";
/**
 * Get the authorization url to redirect user to Xero.
 */
function fetchPostXeroLogin({ reason, stateKey, query, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/xero/login/${reason}/${stateKey}/`, {
        method: "post",
        query,
        body,
    });
}
exports.fetchPostXeroLogin = fetchPostXeroLogin;
exports.GET_XERO_ORGANISATION_ACCOUNT_KEY = "getXeroOrganisationAccount";
/**
 * No description
 */
function fetchGetXeroOrganisationAccount({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/api/lending/edge/xero/organisation/account/${stateKey}/`, {
        method: "get",
    });
}
exports.fetchGetXeroOrganisationAccount = fetchGetXeroOrganisationAccount;
exports.POST_XERO_ORGANISATION_ACCOUNT_KEY = "postXeroOrganisationAccount";
/**
 * No description
 */
function fetchPostXeroOrganisationAccount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/organisation/account/${stateKey}/`, {
        method: "post",
        body,
    });
}
exports.fetchPostXeroOrganisationAccount = fetchPostXeroOrganisationAccount;
exports.PUT_XERO_ORGANISATION_ACCOUNT_KEY = "putXeroOrganisationAccount";
/**
 * No description
 */
function fetchPutXeroOrganisationAccount({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/api/lending/edge/xero/organisation/account/${stateKey}/`, {
        method: "put",
        body,
    });
}
exports.fetchPutXeroOrganisationAccount = fetchPutXeroOrganisationAccount;
